export default {
	italian: "Italian",
	english: "English",
	japanese: "Japanese",
	french: "French",
	german: "German",
	spanish: "Spanish",
	pause_game: "Pause Game",
	resume_game: "Resume Game",
	map_config: {
		select: "Map configuration",
		none: "No configuration",
		save: "Save configuration",
		load: "Load configuration",
		save_new: "Create new configuration",
		save_overwrite: "Overwrite existing",
		save_mode: "Save mode",
		name: "Configuration name",
		name_optional: "New name (optional)",
		name_placeholder: "E.g. Historic center",
		keep_name: "The name will be kept: {name}",
		overwrite_warning: "The selected configuration will be overwritten. This action cannot be undone.",
		load_warning: "The current map configuration will be overwritten with the selected one.",
		locked_center: "The initial point is locked by the selected map configuration.",
		no_template: "Select a template to manage map configurations.",
		saved: "Configuration saved successfully",
		loaded: "Configuration loaded successfully",
		save_error: "Could not save configuration",
		load_error: "Could not load configuration",
		loading_map: "Loading map...",
		disabled_event_started: "Cannot change configuration after the event has started",
	},
	catalan: "Catalan",
	preview: {
		common_sense: {
			title: "Common Sense Preview",
			open_preview: "Preview",
			unsaved_warning: "This preview includes draft changes that have not been saved yet.",
			start_game: "Start game",
			spin_roulette: "Spin roulette",
			show_rules: "Show rules",
			next_phase: "Next phase",
			finish_challenge: "Finish challenge",
			show_final_ranking: "Final ranking",
			show_challenge_ranking: "Challenge ranking",
			show_result: "Show result",
			back_to_roulette: "Back to roulette",
			back_to_waiting_room: "Back to waiting room",
			resume_game: "Resume game",
			collapse_controls: "Hide controls",
			expand_controls: "Show controls",
			hint_explorer: "Explorer mode: move between screens.",
			hint_game_flow: "Game mode: pick a challenge and follow the game flow.",
			hint_select_round:
				"Select a challenge and, optionally, a booster to set up each preview round.",
			hint_collapse:
				"You can hide this panel with the arrow to see the player screen full size. Open it again anytime with the floating button.",
			tutorial_step_explorer: "Step 1 · Explorer mode",
			tutorial_step_game: "Step 2 · Game mode",
			tutorial_step_select: "Step 1 · Challenge & booster",
			tutorial_step_collapse: "Step 2 · Hide controls",
			tutorial_finish: "Finish",
			dismiss_hints: "Got it",
			tutorial_live_sync_title: "Live preview",
			tutorial_live_sync_text:
				"Changes you make in the template update automatically in this preview. You do not need to reload the page—edit and see the result right away.",
			jump_to_phase: "Jump to phase",
			step_waiting: "Waiting room",
			step_roulette: "Roulette",
			step_rules: "Rules",
			step_play: "Challenge",
			step_result: "Result",
			step_challenge_ranking: "Challenge ranking",
			step_final_ranking: "Final ranking",
		},
	},
	general: {
		link_monitors: "Link Facilitators",
		are_you_sure: "Are you sure?",
		preview_not_able: "Preview not available",
		gateway_preview_language: "Idioma",
		gateway_preview_settings: "Settings",
		download: "Download",
		budget: "Budget",
		download_image: "Download image",
		join: "Join",
		play_video: "Play video",
		slides: "Slides",
		change: "Change name",
		wrong_link: "The link is not valid or has expired, please contact the person who sent you the link.",
		point_gain: "Points gained",
		point_loss: "Points lost",
		back: "Back",
		go: "Go",
		select: "Select",
		next: "Next",
		team: "Team",
		teams: "Teams",
		round: "Round",
		ranking: "Ranking",
		results: "Results",
		total: "Total",
		remaining: "Remaining",
		answer: "Answer",
		units: "Available",
		shop: "Shop",
		ingredients: "Ingredients",
		rices: "Rice",
		plates: "Plates",
		choosing: "Choosing",
		save: "Save",
		saved: "Saved",
		cancel: "Cancel",
		collabo_title: "Collaboration App",
		name: "Name",
		buy: "Buy",
		photo: "Photo",
		redo: "Redo",
		password: "Password",
		exit: "Exit",
		canceled: "Cancelled",
		event: "Event",
		day: "Day",
		ingredient: "Ingredient",
		points: "Points",
		position: "Position",
		start: "Start",
		from: "Up to",
		error: "Error",
		chat: "Messages",
		game_master: "STAFF",
		options: "Options",
		reactions: "Reactions",
		team_name: "Team Name",
		option_organizer: "Facilitator options",
		btn_send_answer: "Send answer",
		btn_continue: "Continue",
		correct_answer: "Correct answer",
		incorrect_answer: "Wrong answer",
		challenge_complete: "Challenge completed",
		try_again: "Error, try again",
		save_changed: "Saved changes",
		instructor: "Facilitator",
		ranking_block: "The admin has hidden the ranking",
		ranking_hidden: "The ranking is hidden",
		ranking_display: {
			normal: "Normal",
			cooperative: "Cooperative",
			both: "Both",
			hidden: "Hidden",
			slides: "Slides"
		},
		close: "Close",
		copy_link: "Copy link",
		go_to_link: "Go to link",
		enter_team_name: "Enter team name",
		organizer_options: "Facilitator options",
		staff_warning: "Don't touch anything if you're not a staff member",
		agency: "Distributor",
		delete: "Delete",
		download_pdf: "Download PDF",
		updated: "updated",
		created: "created",
		update: "update",
		create: "create",
		filters: "Filters",
		apply_filters: "Apply filters",
		clear_filters: "Clear filters",
		search: "Search",
		add: "Add",
		edit: "Edit",
		accept: "Accept",
		unsaved_changes: "There are unsaved changes",
		en: "English",
		es: "Spanish",
		yes: "Yes",
		no: "No",
		ipad_title: "Scavenger Hunt App",
		tapas_title: "Culinary App",
		utq_title: "Rally App",
		action_title: "Contest App & Construction App",
		hours: "Hours",
		minutes: "Minutes",
		new: "New",
		mark_all_read: "Mark all as read",
		name_app: "TEAMING APP",
		hello: "Hello",
		reload_app: "Reload app",
		change_monitor: "Change facilitator",
		must: "Mandatory",
		first: "First",
		incorrect_fields: "There are incorrect fields in the form",
		answer_correct: "Correct answer",
		answer_incorrect: "Incorrect answer",
		pair_a: "Pair A ",
		pair_b: "Pair B ",
		order_colon: "Order: ",
		quiz_multi: "Multiple choice quiz",
		answer_auto: "Self-correcting answer",
		order: "Order",
		click_add: "Click to add",
		click_upload: "Click to upload",
		upload: "Upload",
		uploading: "Uploading...",
		quiz: "Quiz",
		pairs: "Pairs",
		min_answers: "There must be a minimum of {min} answers",
		max_answers: "The limit of answers is {max}",
		file_large: "File too large, the maximum is 50MB",
		new_item: "New item",
		add_item: "Add an item",
		missing_items: "No items added",
		select_item: "Select an item",
		total_price: "Total {total_price}€",
		app_activity_plus: "+ App Activity",
		app_activity: "App Activity",
		url_admin: "Setup Link",
		url_gm: "Facilitator Link",
		preview: "Preview",
		actions: "Actions",
		name_company: "Teaming App",
		challenges: "Challenges",
		all: "All",
		new_contact: "New contact",
		missing_contacts: "No contacts added",
		select_contact: "Select a contact",
		demo_upper: "DEMO",
		demo_mode: "Demo mode",
		start_demo_mode: "Start demo mode",
		stop_demo_mode: "Stop demo mode",
		demo_mode_title: "Start demo mode",
		demo_mode_stop_title: "Stop demo mode",
		demo_mode_info_duration: "Demo mode lasts a maximum of 30 minutes.",
		demo_mode_info_alert: "Players will see an alert indicating they are in demo mode.",
		demo_mode_info_reset: "All content generated during the demo will be deleted.",
		demo_mode_info_stop: "You can stop the demo manually from this same button.",
		demo_mode_time_left: "Time left in demo: {time}",
		demo_mode_confirm_start: "Start demo",
		demo_mode_confirm_stop: "Stop demo and reset",
		demo_mode_started: "Demo mode started",
		demo_mode_stopped: "Demo mode stopped and the game was reset",
		demo_mode_banner: "You are playing in demo mode. Progress will be deleted.",
		demo_mode_active: "Demo mode is active",
		add_contact: "Add a contact",
		invalid_url: "The URL is not valid",
		round_remaining: "Round remaining",
		cluedo_ai_title: "Investigation App",
		cluedo_ai_act: "Investigation App",
		you: "You",
		open: "Open",
		chat_with_gm: "Chat with the Facilitator",
		not_answered: "Not answered",
		history: "History",
		acceptAll: "Accept all",
		delivered: "Delivered",
		pending: "Pending",
		one_vs_all_questions: "1 vs all questions",
		question: "Question",
		bingo_title: "Musical Bingo App",
		common_sense_title: "Common Sense App",
		accept_event: "Do you want to accept this event?",
		reject: "Reject",
		test_speed: "Test connection speed",
		testing_speed: "Testing Speed...",
		speed_test_results: "Speed Test Results",
		speed_test_failed: "Error testing speed",
		unable_to_complete_speed_test: "Unable to complete the speed test. Please try again.",
		excellent_speed: "Excellent speed!",
		good_speed: "Good speed!",
		slow_speed: "Slow speed!",
		your_connection_is_very_fast: "Your connection is very fast!",
		your_connection_is_decent: "Your connection is decent!",
		your_connection_needs_improvement: "Your connection needs improvement!",
		test_audio: "Test audio",
		testing_audio: "Playing audio...",
		stop_audio: "Stop audio",
		audio_test_results: "Audio test",
		audio_test_success: "If you heard the sound, audio is working correctly.",
		audio_test_failed: "Error testing audio",
		unable_to_complete_audio_test: "Could not play the audio. Check the device volume and permissions.",
		submit: "Submit",
		plates_rices: "Plates/Rices",
		not_started: "The event has not started yet",
		no_picture: "No team picture",
		upload_team_picture: "Team picture",
		done: "Done",
		challenge: "Challenge",
		no_data: "No data",
	
		show_qr: "Show QR code",
		slides_tooltip: "Images that can be shown on the ranking screen to introduce or start the game.",
	},
	join_lobby: {
		title: "Join Lobby",
		subtitle: "Enter your name and wait until the staff creates the teams.",
		enable: "Enable waiting room",
		demo_disabled: "JoinLobby cannot be enabled for demo events.",
		use_locations: "Use locations",
		locations_before_link_hint:
			"Make sure locations are set correctly before sharing the lobby link with players.",
		locations: "Locations",
		locations_placeholder: "Type a location and press enter",
		location: "Location",
		location_placeholder: "Select your location",
		name_placeholder: "Enter your name",
		join_lobby: "Waiting room",
		waiting_staff: "You are in the lobby. The staff will create the teams soon.",
		players_online: "Players online",
		no_location: "No location",
		join_random_team: "Join a random team",
		staff_title: "JoinLobby settings",
		lobby_link: "Lobby link",
		players_per_team: "Players per team",
		players_per_team_location: "Players per team ({location})",
		teams: "Teams",
		total_players: "Total players",
		total_players_with_count: "Total players: {count}",
		total_teams_with_count: "Total teams: {count}",
		teams_will_be_created: "{count} teams will be created",
		teams_already_created_message:
			"Teams are already created. Players can now join a random team using the lobby URL above.",
		create_teams: "Create teams",
		teams_created: "Teams created",
		button_tooltip: "Allows players to join the activities and then form the teams",
		enable_tooltip: "Allows participants to enter a waiting room to create random teams or join predefined teams. It is mainly used for online activities or in specific cases.",
	},
	player_views: {
		event: {},
		home: {
			user_registered: "User registered",
			active_events: "View active events",
			insert_code: "Enter event code // team",
			qr_scan: "Scan QR",
			code_event: "Event code",
			code_team: "Team code",
			event_not_exist: "This event does not exist",
			team_not_exist: "This team does not exist"
		},
		player_view: {}
	},
	public_views: {
		tapas: {
			presentation_tapas: {
				end: "End of presentation"
			},
			ranking_tapas: {
				round_ends: "Round ends",
				team_turn: "Team turn",
				choice_type: "Choice type",
				choice_round: "Choice round",
				total_round: "Total round",
				time_preparation: "Preparation time"
			},
			results_tapas: {}
		},
		utq: {
			ranking_utq: {
				round_ends: "Round ends",
				points_upper: "POINTS",
				points_abbr: "pts",
				challenge_upper: "CHALLENGE",
				challenges_done: "Challenges",
				team_upper: "TEAM",
				team_fallback: "Team",
				position_upper: "POSITION",
				round_time_left: "Round time left",
				no_teams: "No teams in the ranking yet"
			},
			results_utq: {
				team_upper: "TEAM",
				position_upper: "POSITION",
				points_upper: "POINTS"
			}
		},
		collabo: {
			last_buildings: "Last Buildings",
			buildings: "Buildings",
			join_event: "Join the event",
			next_objective: "Next objective",
			all_objectives_completed: "All objectives completed",
			objective: "Objective",
			objective_completed: "The objective has been completed",
			new_buildings_unlocked: "NEW BUILDINGS UNLOCKED",
			skyscraper_unlocked: "You can now build the skyscraper",
			ranking_title_default: "Ranking"
		},
		team_picker: {
			title: "Team list",
			tooltip: "Generates a link so teams can choose which team they want to join",
			subtitle: "Find and view teams by searching their name or ID",
			search_placeholder: "Search by team name or ID...",
			no_teams_found: "No teams found",
			try_adjusting_search: "Try adjusting your search query",
			no_teams_available: "No teams available",
			showing_results: "Showing {count} of {total} teams",
			points: "Points",
			id: "ID"
		},
		event_lobby: {
			title: "Waiting room",
			join_game: "Join game",
			player_photo_optional: "Player photo (Optional)"
		},
		actionChallenge: {
			ranking_action_challenge: {
				press_button_view_ranking: "Press the button to view the ranking",
				view_ranking: "View ranking"
			}
		}
	},
	tapas: {
		change_main_ingredient: "Change main ingredient",
		tapas_player: {
			new_challenge: "New challenge",
			change_name: "Change name",
			time_choose: "Time to choose",
			presentation_in: "Presentation in",
			final_presentation: "Final presentation",
			default_keyword: "Default keyword",
			dish_name_PC: "Paella name",
			dish_name_Tapas: "Tapa name",
			dish_name_MS: "Sangria name",
			dish_name: "Name of ",
			dish_photo: "Photo of ",
			team_photo: "Team photo",
			dish_photo_PC: "Paella photo",
			dish_photo_Tapas: "Tapa photo",
			dish_photo_MS: "Sangria photo",
			available_money: "Available money",
			choose_ingredient: "Choose ingredient",
			team_choosing: "Team choosing",
			choose_rice: "Choose rice",
			choose_plates: "Choose plate",
			choose_plates_rices: "Choose plates/rices",
			choose_decoration: "Choose decoration/extra",
			change_team_name: "Change team name",
			buy_confirm: "Confirm purchase",
			meal_photo: "Meal photo",
			exit_event: "Exit event",
			answer_correct: "The answer is correct",
			answer_incorrect: "The answer is incorrect",
			name_sent: "Name sent",
			item_purhased: "Item purchased, you can now go pick it up at the store",
			no_unit: "No units available",
			password_incorrect: "Incorrect password",
			name_changed: "Name changed",
			item_purchased: "Purchased utensil",
			item_already_purchased: "Your team has already purchased this item",
			ingredient_history: "Ingredient History",
			current_ingredients: "Current Ingredients",
			shop_items: "Shop Items",
			team_info: "Team Information",
			current_money: "Current Money",
			not_set: "Not set",
			team_name: "Team Name"
		},
		change_time: "Change time"
	},
	modals: {
		upload_photo: {
			change_camera: "Change Camera",
			upload_photo: "Upload Photo",
			photo_success: "Photo sent"
		}
	},
	stores: {
		tapas: {
			main_ingredient: "Compulsory ingredient",
			global_winner: "Global",
			flavour_winner: "Flavour",
			presentation_winner: "Present.",
			defense_winner: "Defense",
			money_winner: "Money",
			photo_tapa: "P. TAPA",
			photo_team: "P. TEAM",
			tapa: "TAPA",
			position: "POSITION",
			points: "POINTS"
		}
	},
	chat: {
		message: "Message",
		message_placeholder: "Type",
		message_btn: "Send message",
		send: "Sent",
		read: "Read",
		new_message_summary: "New chat message",
		new_message_detail: "You have a new message from STAFF"
	},
	ipadHunt: {
		ipadHunt_player: {
			must_challenge: "Compulsory challenge",
			modal_password: "Ask a member of the STAFF for the password.",
			modal_error_download_title: "Content not saved",
			modal_error_download_text: "Download content again",
			modal_download_content_title: "Downloading content",
			modal_download_content_text: "Downloading content",
			modal_error_location_title: "Location not available",
			modal_error_location_text: "Give the app permission to use your location or contact a member of the staff.",
			reload_app: "Refresh app",
			content_correct: "Content downloaded correctly",
			content_incorrect: "There are errors in the content. Please download again.",
			delete_content: "Redownload content",
			answer_send: "Your answer has been submitted. You will receive the corresponding points in a few minutes.",
			match: "Match",
			take_photo: "Take photo",
			take_video: "Take video",
			error_wrong_password: "Wrong password",
			error_no_answer: "Answer not detected",
			error_order: "You have to order the answers",
			challenge_camera: "Challenge camera",
			modal_challenge_title: "TEST",
			modal_challenge_localization_correct: "Correct Location",
			modal_challenge_localization_incorrect: "Location not available",
			modal_challenge_ok: "Challenge completed correctly",
			reset_challenge: "Reset initial challenge",
			challenge_reset: "Challenge reset correctly",
			no_active_challenge: "No active challenge found",
			show_start_challenges: "Show Start Challenges",
			start_challenges_shown: "Challenge(s) will be shown again",
			no_start_challenges: "No start challenges found",
			test_camera: "Test camera",
			modal_test_title: "TEST",
			modal_test_localization_correct: "Correct location",
			modal_test_localization_incorrect: "Location not available",
			modal_test_ok: "Correct test",
			scan_qr: "Scan QR",
			qr_scanned: "QR Code Scanned!",
			error_invalid_qr: "Invalid QR code",
			error_challenge_not_found: "Challenge not available",
			error_challenge_already_done: "This challenge is already completed",
			challenges_blocked: "Challenges Locked",
			challenges_blocked_message: "The facilitator has locked all challenges. Please wait for challenges to be unlocked."
		},
		game_master_ranking: {
			name: "Name",
			points: "Points",
			challenges_done: "Challenges Completed",
			last_challenge: "Last Challenge"
		},
		initial_position: "Initial position",
		finish_position: "Final position",
	
		initial_position_tooltip: "Defines the reference point around which all challenges are initially placed. It is also set as the activity finish point, although it can be changed later.",
		finish_position_tooltip: "It is set as the activity finish point, although it can be changed later.",
	},
	actionChallenge: {
		actionChallenge_player: {
			final_images: "Game images",
			already_done: "You have already done this challenge",
			quiz_already_done: "You have already done this quiz",
			category_completed: "You have already done all the quizzes in this category",
			until: "Worth up to ",
			points: "Points",
			coins: "coins",
			coins_won: "Coins won:",
			audio_error: "Your browser does not support the audio element.",
			shop: "Shop",
			obejcts_buy: "Purchased objects",
			quantity: "Quantity",
			modal_buy_text: "Buy {object} for {money}$",
			error_item_buy_no_money: "You don't have enough money",
			error_item_buy_no_stock: "No stock available",
			error_item_buy_can_not_more: "You cannot buy more of these objects",
			ok_item_buy: "Object purchased, you can now collect it",
			construction_name: "Name of the construction",
			construction_photo: "Photo of the construction",
			need_material: "In this challenge you need materials",
			continue: "CONTINUE",
			send_response: "SEND RESPONSE",
			correct_response: "CORRECT RESPONSE",
			correct_responses: "CORRECT RESPONSES",
			incorrect_response: "INCORRECT RESPONSE",
			money_won: "Money won:",
			response: "Response",
			multiple_answers_hint: "( YOU CAN SELECT MULTIPLE ANSWERS )",
			btn_match: "Match",
			successes: "Successes",
			similarity: "The word matches {similarity_percentage}% to the correct words",
			category_no_elements: "There are no elements in this category",
			not_started: "THE EVENT HAS NOT YET STARTED",
			challenge_warning: "After purchasing a challenge, go to the store to collect the materials to complete it.",
			pick_material: "Go to the store to get the material to start this challenge",
			challenge_send: "The answer has been submitted and will be evaluated by the facilitator",
			return_material: "Return the material to the store to select the next challenge",
			points_won: "Points won",
			wrong_answer: "Incorrect answer",
			game_finished: "The game has finished",
			return_material_finish: "Return the challenge material to the store",
			no_material: "There is currently not enough material to complete this challenge",
			no_money: "You do not have enough money to buy this challenge",
			total_points: "Total points",
			ranking_hidden: "The ranking is hidden",
			ranking_cooperative: "Cooperative ranking",
			ranking_slides: "Slides"
		},
		ranking_action_challenge: {
			press_button_view_ranking: "Press the button to view the ranking",
			view_ranking: "View ranking"
		}
	},
	camera: {
		title_error_modal: "Camera error",
		text_error_modal: "Ask a member of the STAFF for support. Error: ",
		btn_reload_app: "Reload app",
		btn_load_foto: "Add picture from gallery",
		modal_upload_title: "Upload Photo",
		modal_upload_text: "You can upload a picture from the gallery",
		error_no_upload: "Upload a picture first",
		error_upload_photo: "Photo not uploaded, try again"
	},
	analytics: {
		budget_tab: "Budget",
		events_tab: "Events",
		budget_coming_soon: "Budget page (coming soon)",
		number_of_events: "Number of Events",
		total_eur: "Total €",
		mean_eur_event: "€ Mean/Event",
		mean_pax_event: "Pax Mean/Event",
		show_plot_1: "Show Plot 1",
		show_plot_2: "Show Plot 2",
		mean_eur_teambuilding_event: "Average € Teambuilding Event",
		month_1: "January",
		month_2: "February",
		month_3: "March",
		month_4: "April",
		month_5: "May",
		month_6: "June",
		month_7: "July",
		month_8: "August",
		month_9: "September",
		month_10: "October",
		month_11: "November",
		month_12: "December",
		number_of_budget: "Number of budgets",
		number_of_closed_budget: "Number of closed budgets",
		number_of_lost_budget: "Number of lost budgets",
		percent_of_closed_budget: "% of closed budgets",
		number_of_open_budget: "Number of open budgets",
		number_of_won_budget: "Number of won budgets",
		all_months: "All months",
		anual_income: "Annual incomes",
		type_of_activity: "Activity",
		type_of_event_budget: "Type of event",
		euro_event: "€ Event",
		euro_extra: "€ Extra",
		event_place: "Event Location",
		review_summary: "Review Summary",
		total_events: "Total Events",
		events_with_reviews: "Events with Reviews",
		review_rate: "Review Rate",
		category_averages: "Category Averages",
		review_details: "Review Details",
		expectations: "Expectations",
		scale: "Scale",
		game_masters: "Game Masters",
		content: "Content",
		service_prices: "Service/Prices",
		organization: "Organization",
		hire_again: "Hire Again",
		reviews: "reviews",
		event_id: "Event ID",
		activity: "Activity",
		overall_scale: "Overall Scale",
		stars: "stars",
		feedback_tab: "Feedback"
	},
	menu: {
		analytics: "Analytics",
		sales: "Sales",
		budgets: "Quotes",
		clients: "Clients",
		bookings: "Bookings",
		booking_list: "Booking list",
		calendar: "Calendar",
		summaries: "Summaries",
		activities: "Activities",
		demos: "Demos",
		content: "Content",
		settings: "Templates",
		settings_erp: "Settings",
		organization: "Organization",
		activities_erp: "Catalog",
		extras: "Extras Page",
		final_page_budget: "Last Quote Page",
		activities_questions: "Booking Questions",
		credits_consumption: "Credits consumption",
		superadmin: "Superadmin",
		superadmin_credits: "Credits (all orgs)",
		superadmin_organization_stats: "Organization stats",
		favorite_photos: "Favorite photos",
		app_personalization: "App personalization",
		add_staff: "+ Add facilitator",
		my_activities: "My activities",
		staff: "Staff",
		notifications: "Notifications",
		changelog: "What's new",
		logout: "Log out",
		event_service: "Event services",
		switch_organization_label: "Active organization",
		switch_organization_confirm_title: "Switch organization?",
		switch_organization_confirm_message: "You are about to work as \"{name}\". The page will reload and unsaved changes may be lost.",
		switch_organization_confirm: "Switch",
		switch_organization_error: "Could not switch organization"
	},
	superadmin: {
		credits: {
			title: "Credits across all organizations",
			subtitle: "Group consumption by month for invoicing and void test games",
			filters: "Filters",
			organization: "Organization",
			organization_filter_mode: "Org mode",
			organization_include: "Include selected",
			organization_exclude: "Exclude selected",
			all_organizations: "All organizations",
			year: "Year",
			month: "Month",
			status: "Status",
			apply: "Apply",
			total_lines: "Lines",
			total_credits: "Credits",
			total_amount: "Amount",
			monthly_summary: "Monthly summary",
			rows_count: "{count} periods",
			empty_state: "No consumption for these filters",
			empty_lines: "No lines in this period",
			col_organization: "Organization",
			col_period: "Period",
			col_lines: "Lines",
			col_credits: "Credits",
			col_amount: "Amount",
			col_status: "Status",
			col_actions: "Actions",
			col_date: "Date",
			col_event: "Game",
			col_activity: "Activity",
			view_lines: "View lines",
			ensure_batch: "Create batch",
			ensure_batches_all: "Create batches (all)",
			batches_ensured_all: "Batches ready: {count} (failed: {failed})",
			batches_ensured_partial: "Some batches failed ({failed})",
			mark_invoiced: "Invoiced",
			mark_paid: "Paid",
			mark_voided: "Void batch",
			manual_invoice: "Manual invoice",
			manual_invoice_dialog_title: "Manual invoice",
			manual_invoice_dialog_intro:
				"Period {org} · {period} will be marked as invoiced without sending to Holded.",
			manual_invoice_reference: "Invoice reference (optional)",
			manual_invoice_reference_placeholder: "E.g. INV-2026-001",
			manual_invoice_confirm: "Mark as invoiced",
			manual_invoice_success: "Manual invoice registered ({org} · {period})",
			send_holded: "Holded",
			holded_soon: "Holded integration coming soon",
			holded_create: "Create in Holded",
			holded_approve: "Approve Holded",
			holded_send: "Send email",
			holded_send_invoice: "Send Holded invoice",
			holded_create_and_email: "Create + email",
			holded_approve_and_email: "Create + approve + email",
			holded_already_sent: "Sent to Holded",
			holded_create_email_dialog_title: "Create invoice and send email",
			holded_create_email_dialog_intro: "A Holded draft invoice will be created and emailed.",
			holded_send_dialog_title: "Send invoice with Holded",
			holded_send_dialog_intro: "This credit period invoice will be created, approved and emailed in Holded.",
			holded_flow_create_email: "Create + email: creates a Holded draft and sends the email (no approve).",
			holded_flow_approve_email: "Create + approve + email: creates, approves and sends the full invoice.",
			holded_send_dialog_step_create: "An invoice will be created in Holded with this period's credits.",
			holded_send_dialog_step_approve: "The invoice will be approved automatically.",
			holded_send_dialog_step_email: "An email will be sent automatically to the organization ({org} · {period}).",
			holded_send_dialog_note: "Uses the billing email configured on the organization. Make sure Holded contact ID and billing mail are set.",
			holded_will_send_to: "Email will be sent to: {email}",
			holded_contact_ok: "Holded contact ID configured: {id}",
			holded_missing_billing_mail: "Cannot send: organization is missing billing_mail.",
			holded_missing_contact: "Cannot send: organization is missing holded_contact_id.",
			holded_error_approve: "Holded approve failed: {error}",
			holded_error_send: "Invoice was created but the email could not be sent: {error}",
			holded_send_confirm: "Send invoice",
			holded_create_and_email_confirm: "Create and send",
			holded_approve_and_email_confirm: "Create, approve and send",
			holded_create_email_success: "Draft created and sent to {email} (Holded {id})",
			holded_send_invoice_success: "Invoice approved and sent to {email} (Holded {id})",
			holded_create_success: "Holded draft created ({id})",
			holded_approve_success: "Invoice approved in Holded",
			holded_send_success: "Invoice sent by email",
			void_event: "Void game",
			void_line: "Void line",
			unvoid_line: "Unvoid",
			save_line: "Save",
			save_line_success: "Line updated",
			lines_locked_holded: "This period was already sent to Holded. Lines cannot be edited or voided.",
			before_void: "before void",
			void_line_confirm: "Void this credit line?",
			void_line_success: "Line voided",
			unvoid_line_success: "Line restored",
			no_event: "No game",
			void_confirm: "Void all credits for \"{name}\"? Use this to remove test data.",
			void_success: "Voided {count} lines",
			batch_ensured: "Monthly batch ready",
			status_updated: "Status updated",
			load_failed: "Could not load credits summary",
			load_lines_failed: "Could not load lines",
			action_failed: "Could not complete the action",
			status_pending: "Pending",
			status_invoiced: "Invoiced",
			status_paid: "Paid",
			status_voided: "Voided",
			month_1: "January",
			month_2: "February",
			month_3: "March",
			month_4: "April",
			month_5: "May",
			month_6: "June",
			month_7: "July",
			month_8: "August",
			month_9: "September",
			month_10: "October",
			month_11: "November",
			month_12: "December",
		},
		organization_stats: {
			title: "Organization statistics",
			subtitle: "Credits and euros sold, and activities done (voided excluded). Filter by organization and period.",
			filters: "Filters",
			hint_individual: "Detail for the selected organization. Voided lines are excluded.",
			hint_compare: "Totals for all filtered organizations. Select one for the detail view.",
			back_to_comparison: "Back to comparison",
			organization: "Organization",
			organizations: "Organizations",
			organization_filter_mode: "Org mode",
			organization_include: "Include selected",
			organization_exclude: "Exclude selected",
			year: "Year",
			month: "Month",
			all_months: "All months",
			apply: "Apply",
			totals: "Totals",
			select_organization: "Select an organization",
			empty_state: "No credit data for these filters",
			diff_title: "A vs B",
			chart_monthly_credits: "Credits sold per month",
			chart_monthly_euros: "Euros sold per month",
			chart_monthly_activities: "Activities done per month",
			chart_activities: "Top activities by credits",
			chart_intensity_activities: "Intensity: credits per activity",
			chart_compare_ranking: "Credit ranking by organization",
			chart_compare_intensity: "Intensity: credits per activity",
			chart_compare_monthly: "Monthly credit trend by organization",
			chart_compare_activity_mix: "Activity mix by organization",
			table_compare: "Side-by-side comparison",
			col_metric: "Metric",
			col_totals: "Totals",
			kpi_credits: "Credits sold",
			kpi_credit_amount: "Euros sold",
			kpi_events: "Activities done",
			kpi_activities: "Activity types",
			kpi_lines: "Credit lines",
			kpi_credits_per_event: "Credits / activity",
			kpi_avg_amount_per_event: "€ / activity",
			metric_credits: "Credits sold",
			metric_credit_amount: "Euros sold",
			metric_events: "Activities done",
			metric_activities: "Activity types",
			metric_lines: "Credit lines",
			metric_credits_per_event: "Credits / activity",
			metric_avg_amount_per_event: "€ / activity",
			visible_rows: "Visible rows",
			only_with_data: "Only organizations with data",
			series_credits: "Credits sold",
			series_credit_amount: "Euros sold",
			series_events: "Activities done",
			series_credits_per_event: "Credits / activity",
			insight_concentration: "The top 3 activities ({activities}) account for {percent}% of credits",
			load_failed: "Could not load organization statistics",
		},
	},
	changelog: {
		title: "What's new",
		subtitle: "Latest updates and improvements to the application",
		empty: "No updates published yet.",
		new: "New",
		mark_read: "Mark as read",
		mark_all_read: "Mark all as read",
		view_all: "View all",
		got_it: "Got it",
		dismiss: "Dismiss"
	},
	notifications: {
		empty: "No notifications"
	},
	budgets: {
		currency: "Currency",
		budgets: "Quotes",
		status: "Status",
		search: "Search",
		search_name: "Search by name",
		name: "Name",
		client: "Client",
		people: "People",
		date: "Event Date",
		open: "Open",
		won: "Won",
		lost: "Lost",
		all: "All",
		new_budget: "New Quote",
		must_name: "Must have a name",
		budget_validity: "Quote validity",
		hour: "Hour",
		show_total: "Show total",
		language: "Language",
		spanish: "Spanish",
		english: "English",
		conditions: "Conditions",
		extras: "Extras",
		budget: "Quote",
		close_budget: "Close Quote",
		download: "Download",
		select_option: "Select an option",
		select_items: "Select the items to be transferred to the reserve",
		comments_close_budget: "Comments on the closure of the quote",
		convert: "Convert",
		close: "Close",
		back: "Back",
		cancel: "Cancel",
		line: "Add line",
		category: "Category",
		budget_type: "Budget Type",
		auto_price: "Automatic Price",
		total: "Total",
		description: "Description",
		price_tag: "Price Tag",
		pax: "People",
		price: "Price",
		user: "User",
		no_condition: "No conditions",
		comments: "Internal Comments",
		activity: "Activity",
		location: "Location",
		item: "Item",
		first: "First",
		close_convert: "Close/Convert budget",
		comments_budget: "Add comments to the quote",
		type: "Type",
		activities: "Activities",
		budget_description: "Budget description",
		placeholder_budget_description: "Budget description",
		line_type: "Line",
		catalan: "Catalan",
		bulk_add_button: "Add multiple activities",
		bulk_add_title: "Add multiple activities",
		bulk_select_categories: "Select activity categories",
		bulk_categories_placeholder: "Select categories...",
		bulk_or_search_activities: "Or skip categories and search the full catalog.",
		bulk_browse_all_activities: "Search all activities",
		bulk_select_activities_all: "Search and select activities from the full catalog",
		bulk_no_activities_loaded: "No activities are available to add",
		bulk_select_activities: "Select the activities you want to add",
		bulk_no_activities: "No activities found in the selected categories",
		bulk_search_activities_placeholder: "Search by name or code...",
		bulk_no_activities_search: "No activities match your search",
		bulk_pax_hint: "Enter the number of people for the {count} selected activities",
		bulk_default_price_tag: "Default price tag",
		bulk_default_price_tag_placeholder: "Select a price tag...",
		bulk_default_price_tag_none: "No default price tag",
		bulk_next: "Next",
		bulk_add_confirm: "Add to quote"
	},
	bookings: {
		file: "File",
		activity_sheet: "Activity sheet",
		staff_document: "Staff document",
		responsible: "Resp",
		gm_rejected: "Rejected facilitators",
		history_status_pending: "Pending",
		history_status_saved: "Saved",
		history_author: "Author",
		history_source_client: "Client",
		history_source_staff: "Staff",
		history_applied: "Applied",
		history_field_booking_item: "Income",
		history_field_cost_item: "Expenses",
		history_field_game_master_record: "Facilitators",
		file_archive_title: "Document archive",
		file_archive_file: "File",
		file_archive_section: "Section",
		file_archive_status: "Status",
		file_archive_active: "Active",
		file_archive_removed: "Removed",
		media_files: "Media",
		bookings: "Bookings",
		name: "Name",
		client: "Client",
		people: "People",
		pax_tooltip:
			"The number of participants will be finalized 10 days before the event",
		date: "Date",
		search_name: "Search by name",
		search: "Search",
		new_booking: "New Booking",
		general: "General",
		event: "Event",
		activity_information: "Activity information",
		questions: "Questions",
		economics: "Financials",
		ratings: "Ratings",
		language: "Language",
		hour: "Activity time",
		client_logo: "Client Logo",
		logo_client_tooltip:
			"Upload the logo used in compatible event materials and apps.",
		billing_data: "Billing Data (Company name, Tax ID & billing address)",
		billing_data_tooltip:
			"Enter the legal company name, tax ID and address required for invoicing.",
		activities_app: "Activities App",
		type_event: "Event type",
		place: "Location",
		url_location: "Google Maps Link",
		place_information: "Venue information",
		place_information_tooltip: "Is there anything else we should know about the venue?",
		location: "Location",
		must_name: "Must have a name",
		general_information: "General information",
		company_name: "Company name",
		company_name_tooltip: "Person responsible on the day of the event",
		event_general_timing: "General event schedule",
		timetable_plain_tooltip:
			"Add the complete schedule, including arrivals, meetings, meals, the activity and finishing time.",
		extra_information: "Extra information",
		extra_information_internal: "Internal extra information",
		timeline: "Schedule",
		description: "Description",
		add_activity: "Add activity",
		save_before_add_activity: "You must save the form before adding activities.",
		number_teams: "Number of teams",
		team_number_tooltip:
			"Number of teams the participants will be divided into.",
		staff_people: "Number of facilitators",
		teams: "Teams",
		staff: "Facilitators",
		add_team: "Add team",
		add_staff: "+ Add facilitator",
		contact_person: "Contact person",
		add_person_contact: "Add contact person",
		add_item: "Add an item",
		add_questions: "Add questions",
		modify_questions: "Modify questions",
		add: "Add",
		all_questions: "All questions",
		activity_questions: "Booking questions",
		costs: "Costs",
		price: "Price",
		activity: "Activity",
		activities: "Activities",
		activity_ies: "Activity/ies",
		reserve_item: "Services",
		gm_pay: "Staff costs",
		add_gm: "+ Add facilitator",
		game_master: "Facilitator",
		monitor_info: "Facilitator info",
		no_visible_monitor_fields: "No visible information for this facilitator",
		salary: "Salary",
		total: "Total",
		gm_valoration: "Facilitator feedback",
		client_valoration: "Client rating",
		es: "Spanish",
		en: "English",
		cat: "Catalan",
		email: "Email",
		phone: "Phone",
		extra: "Extra",
		online: "Online",
		in_person: "In person",
		booking_activities: "App Activities",
		name_place: "Place name",
		direction_location: "Site URL address",
		add_cost: "Add cost",
		add_field: "Add field",
		review_gm_enjoy: "Did the participants enjoy themselves?",
		review_gm_size: "How would you rate the size of the team of facilitators?",
		review_gm_previous_info: "How would you rate the information provided before the activity?",
		review_gm_started: "When did the activity start?",
		review_gm_material: "Has any material been damaged or lost?",
		review_gm_comments: "Comments or incidents?",
		staff_comments: "Comments",
		review_expectations: "To what extent did our services meet your expectations?",
		review_scale: "On a scale from 1 to 10, how likely are you to recommend our services to someone in your circle?",
		review_gamemasters: "How would you rate the attention of the facilitators during the activity?",
		review_content: "How would you rate the content of the activity?",
		review_service_prices: "How would you rate the price of the services?",
		review_previous_organization: "How would you rate the organization prior to the activity?",
		review_hire_again: "What are the chances that you would hire our service again?",
		review_comments: "Do you have any comments or suggestions for us?",
		expected_not: "They did not meet my expectations",
		expected_more: "I expected more",
		expected_fulfilled: "They fulfilled what I expected",
		expected_exceeded: "They exceeded my expectations",
		very_unsatisfactory: "Very unsatisfactory",
		unsatisfactory: "Unsatisfactory",
		neutral: "Neutral",
		satisfactory: "Satisfactory",
		very_satisfactory: "Very satisfactory",
		no_complaints: "No, there have been many complaints",
		standing_group: "Not much, standing group",
		generally_yes: "Generally yes",
		highly_motivated: "Yes, very motivated group",
		staff_shortage_critic: "There was critically lacking staff",
		staff_shortage: "There was not enough staff to be comfortable",
		correct: "Correct",
		staff_excess: "Excess staff",
		missing_information: "Missing important information",
		missing_details: "Missing details",
		enough: "Enough",
		surplus: "More than enough",
		early_expected: "Earlier than expected",
		on_point: "On time",
		ten_late: "0-10 min late",
		thirty_late: "10-30 min late",
		more_late: "+30 min late",
		user: "User",
		timetable: "Schedule",
		fundae: "FUNDAE",
		fundae_question: "Do you want to subsidize this activity through FUNDAE? Who manages it?",
		fundae_option_no: "No",
		fundae_option_organization: "Yes, managed by {name}",
		fundae_option_client: "Yes, managed by the client",
		files_fundae_client: "FUNDAE documentation (for the client to fill in)",
		files_fundae_client_by_client: "FUNDAE CLIENT — FUNDAE documentation (for the client to fill in)",
		files_fundae_staff_tooltip:
			"Upload the duly completed and signed management contract here. Also the completed participant list.",
		files_fundae_staff: "FUNDAE documentation (filled in for the client)",
		final_client_section: "End client / Intermediary",
		final_client_section_tooltip:
			"Indicate whether the service is booked directly or through an agency, venue or other intermediary.",
		final_client_selector: "Are you an end client or an intermediary?",
		final_client_option_client: "End client",
		final_client_option_agency: "Intermediary",
		final_client_name: "End client name",
		final_client_agency: "Intermediary name",
		final_client_white_label:
			"Can the facilitation team attend in corporate attire, or would you prefer the session to be delivered in white-label format?",
		bill_sent: "Invoice sent",
		custom_fields_section: "Custom fields",
		contract_section: "Contract",
		contract_status: "Contract",
		contract_status_missing_data: "Missing data",
		contract_status_pending_client: "Waiting for client",
		contract_status_pending_signature: "Ready to sign",
		contract_status_signed: "Signed",
		contract_status_inactive: "Not activated",
		contract_status_signed_hidden: "Signed (not activated)",
		contract_missing_keys: "Pending variables",
		contract_not_activated_title: "Contract not activated",
		contract_not_activated_hint: "The contract is not activated on this booking. Activate it so the client can see and sign it.",
		contract_show_to_client: "Activate contract",
		contract_hide_from_client: "Deactivate contract",
		contract_show_to_client_success: "Contract activated",
		contract_hide_from_client_success: "Contract deactivated",
		contract_reset: "Reset contract",
		contract_reset_confirm: "This will delete the signature, the signed PDF and all fields filled by the client. The client will be able to fill them in and sign again. Do you want to continue?",
		contract_reset_success: "Contract reset",
		contract_hint_pending_client: "The client can already see the contract on their link and fill in their fields.",
		contract_hint_pending_signature: "Everything is ready. The client can sign from their link or download the PDF.",
		contract_hint_signed: "The contract is already signed. You can download it from the ⋮ menu.",
		contract_download_pdf: "Download contract PDF",
		contract_download_signed: "Download signed contract",
		contract_fill_client_fields_hint: "Fill in the highlighted fields in the contract. You can sign once they are complete.",
		contract_fill_required_before_next: "You must fill in all fields before continuing to the signature.",
		contract_fill_required_before_sign: "You must complete the name, required fields and signature before signing.",
		contract_sign_choose_option: "Choose one of the two options to sign the contract: sign on the web, or download it and upload it.",
		contract_sign_web: "Sign on the web",
		contract_signer_name: "Signer name",
		contract_clear_signature: "Clear signature",
		contract_sign: "Sign contract",
		contract_sign_cta: "Sign contract",
		contract_continue: "Continue contract",
		contract_view: "View contract",
		contract_minimize: "Minimize",
		contract_save_and_continue: "Save and continue to signature",
		contract_finish_go_booking: "Finish and go to booking",
		contract_upload_signed: "Upload signed contract",
		contract_upload_signed_hint: "Download the PDF, sign it, and upload it here.",
		contract_upload: "Upload PDF",
		contract_upload_pdf_only: "Only PDF files are allowed",
		contract_signed_success: "Contract signed successfully",
		filter_contract_status_label: "Contract status",
		filter_contract_status_description: "Filter bookings by contract status",
		contract_var_name: "Booking name",
		contract_var_date: "Date",
		contract_var_time: "Time",
		contract_var_pax: "People",
		contract_var_language: "Language",
		contract_var_type: "Type (online/in person)",
		contract_var_activity_duration: "Duration",
		contract_var_place_name: "Venue",
		contract_var_place_url: "Venue URL",
		contract_var_place_info: "Venue info",
		contract_var_place_contact: "Venue contact",
		contract_var_billing_data: "Billing data",
		contract_var_extra_info: "Extra info",
		contract_var_timetable_plain: "Schedule",
		contract_var_team_number: "Number of teams",
		contract_var_contact_persons: "Contact persons",
		contract_var_activities: "Activities (economics)",
		contract_var_total_price: "Total price (economics)",
		contract_var_budget_number: "Budget number",
		contract_var_client_name: "Client name",
		contract_var_client_email: "Client email",
		contract_var_signed_date: "Signature date",
		contract_var_signed_time: "Signature time",
		client_information: "Client information",
		app: "App",
		event_details: "Event details",
		staff_persons: "Staff",
		incomes: "Income",
		placeholder_name: "Name",
		alert_name: "Must have a name",
		valoration_available: "RATING (available at the end of the event)",
		new_contact: "New contact",
		very_likely: "Very likely",
		likely: "Likely",
		unlikely: "Unlikely",
		very_unlikely: "Very unlikely",
		media: "Media",
		close_booking: "Close Booking",
		agency_files: "Internal files",
		client_files: "Client files",
		client_files_tooltip:
			"Any files needed for the event, such as the participant list, schedules or other relevant documentation.",
		invoice_files: "Invoice files",
		event_invoice_files: "Event expense invoices",
		upload_expense_invoice: "Upload expense invoice",
		upload_expense_invoice_modal_title: "Upload expense invoice",
		upload_expense_invoice_modal_hint: "You can upload one or more event expense invoices. You will not be able to view uploaded invoices from here.",
		add_file: "Add file",
		price_tag: "Price tag",
		item: "Booking item",
		line: "Line",
		pax: "People",
		auto_price: "Automatic price",
		done: "Finished",
		canceled: "Canceled",
		open: "Open",
		add_question_warning: "The questions you add will not be translated",
		place_contact: "Space contact",
		place_contact_tooltip:
			"Contact details for the person responsible for the venue.",
		detail_canceled: "CANCELLED",
		detail_open: "OPEN",
		detail_closed: "CLOSED",
		communication_platform: "Communication platform",
		communication_url: "Communication URL",
		zoom: "Zoom",
		ms_teams: "MSTeams",
		webex: "Webex",
		google_meet: "GMeet",
		owner: "Owner",
		accepted: "Status",
		staff_main: "Production Manager",
		crm_id: "CRM ID",
		placeholder_crm_id: "CRM ID",
		status: "Status",
		filter_dialog_title: "Filter bookings",
		filter_state_label: "Booking status",
		filter_state_description: "Show only bookings in the selected states (open, finished or cancelled).",
		filter_owner_label: "Booking owner",
		filter_owner_description: "Filter by the person responsible for the booking.",
		filter_main_staff_label: "Production manager",
		filter_main_staff_description: "Filter by the production manager assigned to the booking.",
		filter_fundae_label: "FUNDAE subsidy",
		filter_fundae_description: "Whether the booking is marked as eligible for FUNDAE funding.",
		filter_fundae_files_label: "FUNDAE documentation (filled in for client) (2+ files)",
		filter_fundae_files_description: "Show bookings that have at least two files uploaded in the FUNDAE documentation filled in for the client field.",
		filter_bill_sent_label: "Invoice sent",
		filter_bill_sent_description: "Whether the invoice has been marked as sent for the booking.",
		filter_language_label: "Event language",
		filter_language_description: "Language configured for the booking event.",
	
		crm_id_tooltip: "Identifier of the opportunity or booking in your external CRM.",
		contact_person_tooltip: "Main client contact for event coordination.",
		place_tooltip: "Name of the venue or location where the event will take place.",
		url_location_tooltip: "Add the Google Maps link to the event's exact location.",
		extra_information_tooltip: "Relevant event context information .",
		auto_price_tooltip: "Calculates the price using the configured rate, price tag and number of participants.",
		bill_sent_tooltip: "Select this when the invoice has been sent to the client.",
		responsible_tooltip: "Indicate which facilitator will be the team lead.",
		gm_valoration_tooltip: "Facilitator's internal assessment of the activity, the team and any incidents.",
		client_valoration_tooltip: "Client feedback about the activity, its organization and the service received.",
	},
	activities: {
		activities: "Activities",
		activity: "App",
		game: "App",
		day: "Date",
		enter: "Enter",
		create_activity: "Create Activity",
		sure: "Are you sure?",
		delete: "Delete",
		date_hour: "Date and time",
		name_activity: "Activity name",
		type_activity: "App",
		language: "Language",
		comments: "Comments",
		logo: "Logo",
		demo: "Demo",
		demo_locked_tooltip: "Once the event is created, you can't switch it to demo or remove demo.",
		alert_name_activity: "Give a name to the activity.",
		select_language: "Select a language",
		select_challenge: "Select a challenge",
		select_date: "Select a date",
		select_activity: "Select a template",
		select_name: "Give a name to the activity",
		select_primary_color: "Select a primary color.",
		select_secondary_color: "Select a secondary color.",
		save_error: "Could not {message_request_negative} the event",
		save_ok: "Event {message_request} successfully",
		delete_error: "Could not delete the event",
		delete_ok: "The event has been deleted",
		tl_activity: "{company} Activity",
		click_add: "Click to Add",
		dashboard: "Dashboard",
	
		demo_tooltip: "Select this to create a demonstration activity instead of a live event. It will be limited to two teams and will not spend any credits.",
	},
	demos: {
		demos: "Demos",
		create_demo: "Create Demo"
	},
	content: {
		collabo: {
			presets: "Presets",
			preset: "Preset",
			challenges: "Challenges",
			challenge: "Challenge",
			challenges_placeholder: "Select challenges",
			videos: "Collabo Videos",
			video_item: "Collabo Video",
			videos_placeholder: "Select videos",
			videos_title: "Title",
			description_gm: "Description for the facilitator",
			video: "Video",
			challenge_type: "Challenge type",
			challenge_type_placeholder: "Select challenge type",
			name: "Name",
			material: "Material",
			materials: "Materials",
			materials_placeholder: "Select materials",
			construction: "Construction",
			constructions: "Constructions",
			constructions_placeholder: "Select constructions",
			model3d: "3D Model",
			paint: "Paint",
			statment: "Statement",
			make: "Make",
			find: "Find",
			find_missing: "Find Missing",
			image: "Image",
			subcontent: "Subcontent",
			subcontent_placeholder: "e.g., city_find, flower_pattern",
			description: "Description",
			placeholder_name_id: "Challenge identifier name...",
			alert_name_id: "Give a name to the challenge.",
			placeholder_description: "Challenge description..."
		},
		content: "Content",
		add_new_content: "New",
		discard_and_new_content: "Unsaved changes will be lost. Do you want to create new content?",
		list_content: "Content List",
		no_template: "No Template",
		all: "All",
		ipad: {
			ipad_settings: "Templates",
			ipad_setting: "iPad Template",
			ipad_challenges: "Digital Challenges",
			must: "Mandatory",
			optional: "Optional",
			first: "First",
			content_list: "Content List",
			name: "Name",
			setting: "Setting",
			type: "Template",
			quiz: "Quiz",
			open_text: "Open Text",
			photo: "Photo",
			video: "Video",
			alert: "Alert",
			team_photo: "Team photo",
			order: "Order",
			match: "Match",
			type_challenge: "Type of challenge",
			id_name: "Identifying name",
			password: "Password",
			time: "Time",
			max_points: "Maximum score",
			template: "Template",
			description: "Description",
			file_1: "File 1",
			file_2: "File 2",
			file_3: "File 3",
			placeholder_type: "Select a type",
			alert_type: "Select a challenge type",
			placeholder_name_id: "Challenge identifier name...",
			alert_name_id: "Give a name to the challenge.",
			placeholder_name: "Challenge name...",
			placeholder_password: "Password...",
			placeholder_description: "Challenge description...",
			expected_answer: "Expected Answer",
			placeholder_expected_answer: "Expected answer",
			challenge: "Digital Challenge",
			placeholder_team: "Team..",
		
			template_tooltip: "Select the base template whose content and settings will be copied into the new activity.",
			must_tooltip: "Requires this challenge to be completed following a route order.",
			first_tooltip: "Makes this challenge appear at the start of the experience.",
			password_tooltip: "Code used to unlock or validate access to the challenge.",
			time_tooltip: "Time available to complete the challenge, in seconds. It is informative, when the timer ends the challenge is not closed.",
			max_points_tooltip: "Maximum score that can be earned by completing the challenge.",
		},
		tapas: {
			tapas_settings: "Plantillas",
			tapas_setting: "Tapas Template",
			tapas_challenges: "Culinary Challenges",
			tapas_challenge: "Culinary Challenge",
			ingredients: "Ingredients",
			ingredient: "Ingredient",
			item_shop: "Shop Items",
			item_shop_item: "Shop Item",
			name: "Name",
			type: "Type",
			quiz: "Quiz",
			challenge: "Challenge",
			type_challenge: "Challenge Type",
			id_name: "Identifying name",
			money: "Money",
			template: "Template",
			image: "Image",
			description: "Description",
			placeholder_type: "Select a type",
			alert_type: "Select a challenge type",
			placeholder_name_id: "Identifier name of the challenge...",
			alert_name_id: "Give an identifying name to the challenge.",
			placeholder_name: "Name of the challenge...",
			placeholder_description: "Challenge description...",
			setting: "Setting",
			main_ingredient: "Main ingredient",
			secondary_ingredient: "Secondary ingredient",
			decoration: "Decoration",
			base: "Base",
			quantity: "Quantity",
			quantity_placeholder: "Quantity, e.g., 1 package 200g...",
			objects_per_team: "Units per teams",
			once_per_team: "Only one purchase per team",
			object_shop: "Shop Object",
			challenge_shop: "Challenge Shop",
			change_time: "Change time",
		
			quantity_tooltip: "Amount or serving format of the ingredient, for example “1 pack of 200 g”.",
			objects_per_team_tooltip: "Defines how many units are included in the base stock based on the number of teams.",
			once_per_team_tooltip: "Limits the item to one purchase per team.",
		},
		utq: {
			challenges_utq: "Rally Challenges",
			name: "Name",
			placeholder_name: "Challenge name...",
			id_name: "Identifying name",
			material: "Material",
			placeholder_material: "Material...",
			description: "Description",
			placeholder_description: "Challenge description...",
			description_score: "Score description",
			placeholder_descriptVideoinitial_challengesion_score: "Description of the challenge score...",
			image: "Image",
			quiz: "Quiz",
			challenge: "Rally Challenge",
			placeholder_name_id: "Identifier name of the challenge...",
			alert_name_id: "Provide an identifying name for the challenge.",
			placeholder_description_score: "Description of the challenge score...",
		
			material_tooltip: "List of materials needed to prepare and run the challenge.",
			description_score_tooltip: "Explains how the challenge should be assessed and scored.",
		},
		action: {
			action_settings: "Templates",
			action_setting: "Template",
			quiz: "Money Challenges",
			category_quiz: "Money challenge categories",
			category_quiz_item: "Money Challenge Category",
			challenge: "Initial & Shop Challenges",
			challenge_item: "Initial & Shop Challenge",
			challenges: "Challenges",
			name: "Name",
			category: "Category",
			type: "Type",
			setting: "Template",
			init_challenge: "Initial Challenge",
			init_challenges: "Initial Challenges",
			order: "Order",
			match: "Match",
			quiz_multi: "Multi Quiz",
			text_auto: "Self-Correcting Text",
			type_challenge: "Type of Challenge",
			placeholder_type: "Select a type",
			alert_type: "Select a type of challenge",
			id_name: "Identifying name",
			placeholder_name_id: "Identifier name of the challenge...",
			alert_name_id: "Give an identifying name to the challenge.",
			placeholder_name: "Name of the challenge...",
			description: "Description",
			placeholder_description: "Challenge description...",
			image_quiz: "Quiz image",
			max_money: "Maximum money",
			need_material: "Needs material",
			material: "Material",
			placeholder_material: "Necessary material...",
			expected_answer: "Expected answer",
			placeholder_expected_answer: "Expected answer",
			file_1: "File 1",
			file_2: "File 2",
			action_challenge_quiz: "Money Challenge",
			photo: "Photo",
			video: "Video",
			team_photo: "Team photo",
			template: "Template",
			max_points: "Maximum score",
			cost: "Cost",
			video_duration: "Video duration",
			short_description: "Short description",
			placeholder_short_description: "Short description...",
			help_gm: "Help to score",
			help_file: "Solution Image",
			internal_description: "Internal description",
			placeholder_internal_description: "Internal challenge description...",
			text_data: "Manual correction text",
			text_data_auto: "Automatic correction text",
			object_shop: "Shop Construction Materials",
			object_shop_item: "Shop Construction Material",
			challenge_shop: "Construction Challenges",
			challenge_shop_item: "Construction Challenge",
		
			max_money_tooltip: "Maximum amount of in-game money that can be earned.",
		},
		actionChallengeShopItem: {
			one_per_team: "One per team",
			two_per_team: "Two per team",
			one_per_two_teams: "One for every two teams",
			one_per_three_teams: "One for three teams",
			identifying_name: "Identifying Name",
			identifying_name_placeholder: "Identifier name of the questionnaire...",
			identifying_name_alert: "Provide an identifying name for the questionnaire.",
			image: "Image",
			cost: "Cost",
			max_per_team: "Maximum per team",
			template: "Template",
			default_material: "Default material",
			material_description: "Material description",
			name: "Name",
			name_placeholder: "Name of the challenge...",
			description: "Description",
			description_placeholder: "Description of the challenge...",
		
			max_per_team_tooltip: "Maximum number of units each team can buy.",
			default_material_tooltip: "Defines how many units are included in the base stock based on the number of teams.",
		},
		downloading_content: "Downloading content",
		skip_download: "Continue without waiting",
		skip_download_hint:
			"You can continue now. Remaining files will download in the background when the connection allows.",
		background_download_remaining: "{count} left",
		background_download_in_settings: "Downloading remaining content…",
		exporting_event_content: "Exporting player submissions",
		files_remaining: "files remaining",
		export_transferring_zip: "Starting download...",
		export_uploading_s3: "Uploading ZIP to storage...",
		export_ready_downloading: "ZIP ready, starting download...",
		export_download_button: "Download ZIP",
		player_asset_cache_title: "Preparing offline content",
		player_asset_cache_text: "Saving maps and media to your device for offline use.",
		cluedo_ai: {
			cluedo_ai_settings: "Plantillas",
			cluedo_ai_setting: "Investigation App Template",
			cluedo_ai_title: "Cluedo AI",
			cluedo_ai_act: "Case",
			cluedo_ai_questions: "Questions",
			cluedo_ai_objects: "Objects",
			cluedo_ai_characters: "Suspects",
			duration: "Duration",
			placeholder_duration: "Activity duration",
			image_quiz: "Quiz image",
			image1: "Image 1",
			image2: "Image 2",
			image3: "Image 3",
			description: "Description",
			placeholder_description: "Activity description",
			name: "Name",
			placeholder_name: "Activity Name",
			id_name: "Identifying name",
			placeholder_id_name: "Activity identifying name",
			alert_id_name: "Give the activity an identifying name",
			templates: "Templates",
			act: "Case",
			no_act: "No Case",
			setting: "Setting",
			character: "Character",
			questions: "Questions",
			no_character: "No character",
			no_questions: "No questions",
			key_information: "Key information",
			placeholder_key_information: "Key information",
			placeholder_prompt: "Prompt",
			placeholder_prompt_answer: "Prompt answer",
			placeholder_question: "Question",
			placeholder_answer: "Answer",
			placeholder_name_id: "Challenge identifier name...",
			alert_name_id: "Please provide an identifying name for the challenge.",
			question: "Question",
			answer: "Answer",
			prompt_answer: "Response Prompt",
			points: "Points",
			cluedo_ai_object: "Object",
			cluedo_ai_character: "Suspect",
			cluedo_ai_question: "Question",
			act_char: "Character",
			image: "Image",
			model3d: "3D Model",
			prompt: "Prompt",
			start_message: "Start message",
			placeholder_start_message: "Start message",
			background: "Background",
			add_key_information: "Add key information",
			age: "Age",
			placeholder_age: "Character's age",
			job: "Job",
			placeholder_job: "Character's job",
			personal_information: "Personal information",
			placeholder_personal_information: "Character's personal information",
			personality: "Personality",
			placeholder_personality: "Character's personality",
			context: "Context",
			placeholder_context: "Character's context",
			case_related: "Related case",
			placeholder_case_related: "Character's related case",
			motivation: "Motivation",
			placeholder_motivation: "Character's motivation",
			previous_knowledge: "Previous knowledge",
			placeholder_previous_knowledge: "Previous knowledge of the character",
			relashionship: "Relationships",
			placeholder_relashionship: "Relationships of the character",
			description_player: "Description of the character",
			placeholder_description_player: "Description of the character",
			short_text: "Short text"
		},
		no_act: "No Case",
		bingo: {
			bingo_challenges: "Musical Bingo Challenges",
			bingo_challenge: "Musical Bingo Challenge",
			bingo_songs: "Songs",
			bingo_song: "Song",
			bingo_sets: "Set",
			quiz: "Quiz",
			poll: "Poll",
			two_vs_two: "2 vs 2",
			challenge_type: "Challenge type",
			set: "Set",
			one_vs_all: "1 vs all",
			image: "Image",
			fill: "Fill",
			photo: "Photo",
			song_image: "Image of the song",
			set_image: "Image of the set",
			song_file: "File of the song",
			challenge: "Challenges (will be played in order)",
			song_artist: "Artist",
			song_artist_placeholder: "Song artist...",
			challenge_song: "Challenge song",
			winning_song: "Winning song",
			image_challenge_1: "Challenge image 1",
			image_challenge_2: "Challenge image 2",
			image_post_1: "Post image 1",
			image_post_2: "Post image 2",
		
			challenge_song_tooltip: "Audio used to introduce or accompany challenges.",
			winning_song_tooltip: "Audio played when there is a winner.",
		},
		common_sense: {
			challenges: "Common Sense Challenges",
			challenge: "Common Sense Challenge",
			name: "Name",
			settings: "Common Sense Settings",
			setting: "Common Sense Setting",
			id_name: "Identifier name",
			name_placeholder: "Name...",
			name_alert: "Please add a name.",
			primary_color: "Primary color",
			personalization: "Personalization",
			theme: "Theme",
			challenges_title: "Challenges",
			client_personalization: "Client personalization",
			font_family: "Font",
			client_language: "Client language",
			background_image: "Background image",
			event_logo: "Event logo",
			theme_editable: "Theme editable",
			questions_editable: "Questions editable",
			questions_choose: "Questions selectable",
			flow_mode_enabled: "Flow enabled by default",
			flow_order: "Default Flow order",
			flow_order_hint: "Select the template challenges first, then drag them here to define the default order.",
			challenge_type: "Challenge type",
			challenge_type_alert: "Please select a challenge type.",
			time_results: "Result time",
			questions: "Questions",
			quiz: "Quiz",
			fair_prize: "Fair prize",
			timeline: "Timeline",
			questions_editor: {
				questions_count: "{type} · {count} questions",
				apply_time_to_all: "Apply time to all",
				add_question: "Add question",
				no_questions_readonly: "This challenge has no questions.",
				no_questions_empty: "Add the first question for this Common Sense challenge.",
				question_label: "Question",
				answers_title: "Answers (first is correct)",
				add_answer: "Add answer",
				correct_answer_placeholder: "Correct answer",
				incorrect_answer_placeholder: "Incorrect answer {n}",
				fair_prize_correct_answer: "Correct answer",
				min_slider: "Min slider",
				max_slider: "Max slider",
				interval: "Interval",
				order_hint_start: "Order hint (start — left / first)",
				order_hint_end: "Order hint (end — right / last)",
				order_hint_start_placeholder: "e.g. Older, Top, First",
				order_hint_end_placeholder: "e.g. Newer, Bottom, Last",
				order_hint_help:
					"Shown to players at each end of the timeline so they know which way to order (e.g. old → new or top → bottom).",
				correct_order: "Correct order",
				add_item: "Add item",
				timeline_item_placeholder: "Item {n}",
				image: "Image",
				image_optional: "Image (optional)",
				question_image: "Question image",
				upload_image: "Upload image",
				remove: "Remove",
				question_header: "Question {n}",
				question_added: "Question added",
				time_updated: "Time updated",
			},
		}
	},
	settings: {
		settings: "Templates",
		settings_list: "Template list",
		ipad: {
			name: "Name",
			id_name: "Identifying name",
			placeholder_name_id: "Identifier name for the challenge...",
			alert_name_id: "Please give an identifying name to the challenge.",
			main_color: "Main color",
			secondary_color: "Secondary color",
			stopwatch_color: "Timer color",
			background_image: "Background image",
			event_logo: "Event logo",
			points_icon: "Points icon",
			challenges: "Challenges",
			challenge: "Template",
		
			main_color_tooltip: "Primary color used in the template interface.",
			secondary_color_tooltip: "Secondary color used to highlight interface elements.",
			stopwatch_color_tooltip: "Color used to display the activity timer.",
			background_image_tooltip: "Background image applied to challenge screens.",
			points_icon_tooltip: "Icon used to represent points earned during the game.",
			challenges_tooltip: "Selects the challenges available in this template.",
		},
		tapas: {
			name: "Name",
			id_name: "Identifying name",
			placeholder_name_id: "Identifier name for the challenge...",
			alert_name_id: "Put an identifier name for the challenge.",
			secondary: "Secondary",
			decoration: "Decoration",
			processing_time: "Cooking time",
			ingredients: "Ingredients",
			item_shop: "Shop",
			tapas_challenges: "Culinary challenges",
			keyword: "Dish",
			setting: "Template",
			error_secondary_ingredients: "If secondary ingredients are enabled, you must select at least one primary and one secondary ingredient",
			error_missing_main_ingredient: "At least one primary ingredient is missing from the template",
			error_missing_secondary_ingredient: "At least one secondary ingredient is missing from the template",
			error_missing_main_and_secondary: "Primary and secondary ingredients are missing from the template",
		
			secondary_tooltip: "Defines how many secondary ingredients appear in the ingredient selection. One main ingredient is always assigned at random.",
			ingredients_tooltip: "Select the ingredients available during the ingredient selection phase.",
			item_shop_tooltip: "Selects the items available in the in-game shop.",
			keyword_tooltip: "The dish prepared using this template.",
		},
		action: {
			name: "Name",
			id_name: "Identifying name",
			placeholder_name_id: "Identifier name of the challenge...",
			alert_name_id: "Please provide an identifier name for the challenge.",
			challenges: "Store Challenges",
			initial_shop_challenges: "Initial and shop challenges",
			categories: "Money challenge categories",
			challenge: "Template",
			shop: "Shop",
			construction_challenges: "Construction challenges",
			game_mode: "Game Mode",
			menu_points: "Menu points",
			initial_challenges: "Initial challenges",
			quiz: "Money Challenges",
			menu_items: "Menu items",
			store_mode: "Construction",
			contest_mode: "Contest",
		
			game_mode_tooltip: "Chooses whether the template is for Contest App or Construction App; dependent fields will change.",
			menu_items_tooltip: "Selects the sections shown in the activity menu.",
		},
		cluedo_ai: {
			name: "Name",
			placeholder_name: "Challenge name...",
			id_name: "Identifying name",
			image: "Image",
			description: "Description",
			placeholder_description: "Challenge description...",
			acts: "Acts (The order in which they are added will be the order in which they appear)",
			setting: "Setting",
			settings: "Settings",
			primary_color: "Primary color",
			secondary_color: "Secondary color",
			timer_color: "Timer color",
			points_icon: "Points icon"
		}
	},
	erp_settings: {
		exclude_web: "Exclude from web",
		category: "Categories",
		main_category: "Main category",
		sub_category: "Sub category",
		create_sub_category: "New category",
		organization: "Organization",
		name: "Name",
		placeholder_name: "Name",
		alert_name: "Must have a name",
		logo: "Logo",
		default_image: "Default image",
		color_primary_document: "Document primary color",
		color_secondary_document: "Document secondary color",
		billing: "Billing",
		placeholder_billing: "Billing data...",
		billing_mail: "Billing email",
		placeholder_billing_mail: "email@company.com",
		holded_contact_id: "Holded contact ID",
		placeholder_holded_contact_id: "Contact ID in Holded",
		vat_type: "VAT type",
		vat_type_21: "21%",
		vat_type_exempt: "Exempt",
		gm_info_text: "Notice for facilitators / instructors",
		placeholder_gm_info_text: "Text that facilitators will see when opening a booking...",
		list_activities: "List of Activities",
		new_activity: "New Activity",
		search: "Search",
		placeholder_search: "Search by name",
		in_person: "In-person",
		online: "Online",
		modality: "Modality",
		alert_modality: "Select a modality",
		general_media: "Media",
		pricing_list: "Price List",
		activity_name: "Name",
		placeholder_activity_name: "Activity name (Client)",
		duration: "Duration",
		placeholder_duration: "Activity Duration",
		description: "Description",
		placeholder_description: "Activity Description",
		requirements: "Requirements",
		placeholder_requirements: "Activity Requirements",
		includes: "Includes",
		placeholder_includes: "What the activity includes",
		dynamic: "Dynamic",
		placeholder_dynamic: "Activity Dynamics",
		budget_description: "Quote Description",
		placeholder_budget_description: "Quote Description",
		media: "Media only in this language",
		extras: "Extras",
		price: "Price",
		activity: "Activity",
		type_price: "Price Type",
		alert_type_price: "Select a price type",
		new_extra: "New Extra",
		preview_pdf: "Preview PDF",
		staff_document: "Staff document",
		extra_deleted: "The extra has been deleted",
		extra_not_deleted: "The extra has not been deleted",
		placeholder_name_extra: "Extra Name",
		placeholder_description_extra: "Extra Description",
		extra: "Extra",
		total: "Total",
		by_person: "Per Person",
		final_page_budget: "Last Quote Page",
		new_final_page_budget: "New Last Quote Page",
		final_page_budget_deleted: "The last quote page has been deleted",
		final_page_budget_not_deleted: "The last quote page could not be deleted",
		placeholder_description_activity: "Description of the activity",
		question: "Question",
		placeholder_question: "Question",
		all_activities: "All activities",
		no_activity: "No activity",
		placeholder_activity: "Filter by activity",
		questions_activities: "Questions about activities",
		link_app: "App Link",
		youtube_url: "YouTube URL",
		placeholder_youtube_url: "YouTube video URL",
		code: "Code",
		placeholder_code: "Activity code",
		question_booking: "Booking questions",
		new_question_booking: "New booking question",
		event_service: "Event services",
		fixed: "Fixed",
		add_price: "Add price",
		location: "Location",
		link_location: "Location link",
		placeholder_location: "Event service location",
		placeholder_link_location: "Event service location link",
		event_service_name: "Event service name",
		placeholder_event_service_name: "Event service name",
		new_event_service: "New Event Service"
	},
	previews: {
		menu: "Menu"
	},
	login: {
		description: "{company} application for conducting Team Building events",
		email: "Email",
		placeholder_email: "Your email",
		password: "Password",
		placeholder_password: "At least 8 characters",
		sign_in: "Sign In",
		invalid_credentials: "Incorrect credentials",
		forgor_password: "Forgot password"
	},
	formGenerator: {
		pricing: {
			new_price: "+ New price line",
			min_persons: "Minimum participants",
			max_persons: "Maximum participants",
			total_price: "Total price",
			person_price: "Price per participant",
			price: "Price"
		}
	},
	dialogs: {
		sure: "Are you sure?",
		erase: "Delete",
		erase_record: "Delete record",
		delete_team: "Delete team",
		confirm_delete_team: "Are you sure you want to delete the team",
		delete: "Delete",
		delete_colon: "Delete: ",
		cancel: "Cancel",
		name: "Name",
		add: "Add",
		placeholder_team: "Team..",
		edit_team: "Edit team",
		save: "Save",
		demo_limit: "Demo activities only allow 2 teams",
		link_staff: "Staff link",
		link_admin: "Admin link",
		link_results: "Results link",
		go_results: "Go to results",
		add_team: "Add team",
		material_recalculate: "When creating the team, the material will be recalculated",
		material_tab_no_update_add_teams: "Material tab won't update if you add teams",
		warning: "Warning",
		add_team_money: "Add team money",
		link_teams: "Teams link",
		challenge_delete: "The challenge will be deleted: ",
		create: "Create",
		challenge: "Challenge",
		item: "Item",
		stock: "Item",
		placeholder_challenge: "Select a challenge",
		warning_change_template: "Changing the template will delete all challenges",
		team: "Team",
		teams: "Teams",
		points_negative: "Points (can be negative)",
		money_negative: "Amount (can be negative)",
		minutes: "Minutes",
		seconds: "Seconds",
		substract: "Subtract",
		expected_answer: "Expected answer: ",
		challenge_score: "Score challenge",
		activate: "Activate",
		material_recalculate_delete: "Deleting the team will recalculate the material",
		add_route: "Add route",
		confirm: "Confirm",
		accept: "Accept",
		activity: "Activity",
		language: "Language",
		placeholder_language: "Select a language",
		logo: "Logo",
		sure_delete_acitivty: "Are you sure you want to delete the activity?",
		add_favorite: "Add to favorites",
		delete_favorite: "Remove from favorites",
		date: "Date",
		unsaved_changes_content: "Are you sure?",
		unsaved_changes_title: "Unsaved changes will be lost",
		stay: "Stay",
		exit: "Exit",
		client_validate: "Customer data needs to be validated",
		close_booking: "Close booking",
		cancel_reason: "Reason for cancellation",
		finish: "Finish",
		favorite_challenge: "Favorite",
		object: "Object",
		character: "Character",
		key_information: "Key Information",
		give: "Give",
		key_information_done: "Key information completed",
		give_key_information: "Give key information",
		team_components_precreated_only: "Team members are only used in online games, where users select their team from the teams page.",
		team_components: "Team components",
		team_components_placeholder: "Add a component and press enter",
		close: "Close"
	},
	customization: {
		common_sense: {
			subtitle: "Customize your Common Sense experience",
			not_found: "This customization link is not valid.",
			tab_personalization: "Personalization",
			tab_create_content: "Create content",
			challenges_selection: "Challenge selection",
			challenges_selection_hint: "Enable the challenges you want to use. You can expand each one to preview questions and answers (read-only).",
			challenges_view: "Challenges",
			challenges_view_hint: "Read-only view. Expand each challenge to see questions and answers.",
			read_only_notice: "This link is read-only. You can review the content but cannot change, enable, or add challenges.",
			no_challenges: "No challenges configured for this template.",
			upload_image: "Upload image",
			event_logo: "Event logo",
			event_logo_hint: "This logo will appear on the public game screen when this template is selected for an event.",
			logo_saved: "Logo saved",
			logo_save_error: "Could not save the logo",
			public_link: "Client customization link",
			public_link_hint: "Share this link with your client. It is generated when the setting is saved.",
			challenges_client: "Client-selected challenges",
			no_questions: "No questions configured.",
			untitled_question: "Untitled question",
			untitled_step: "Untitled step",
			correct: "correct",
			correct_answer: "Correct answer",
			select_challenge: "Select a challenge",
			new_challenge: "New challenge",
			add_challenge: "Add challenge",
			challenge_added: "Challenge added",
			challenge_name_required: "Enter a name for the challenge",
			delete_challenge: "Delete",
			delete_challenge_confirm_title: "Delete this challenge?",
			delete_challenge_confirm_message:
				"«{name}» will be removed from this template. This cannot be undone.",
			challenge_deleted: "Challenge deleted",
			nothing_enabled: "No customization options are enabled for this setting.",
			client_edit: "Client can edit this challenge",
			autosave_saving: "Saving…",
			autosave_saved: "All changes saved",
			autosave_error: "Could not save. Please try again.",
			challenges_client_hint:
				"You can only pick challenges that are already selected in «Challenges».",
			challenges_client_select_master_first:
				"Select at least one challenge in «Challenges» before configuring client challenges.",
		},
	},
	gm: {
		modals: {
			add_monitor: "+ Add facilitator",
			save: "Save",
			name: "Facilitator name",
			placeholder_name: "Facilitator name",
			saved_monitor: "Facilitator saved",
			continue: "Continue",
			change: "Change",
			exit: "Exit",
			cancel: "Cancel",
			exit_event: "Exit the event",
			password: "Password",
			enter_name: "Enter your name"
		},
		ranking: {
			show: "Show Ranking",
			hide: "Hide Ranking"
		},
		dashboards: {
			teams: "Teams",
			credits_to_consume: "Credits to consume",
			unit_cost: "unit cost",
			links: "Links",
			name: "Team name",
			chat: "Messages",
			configuration: "General Setup",
			configuration_activity: "Activity Setup",
			link_ranking: "Ranking Link",
			link_results: "Results link",
			link_monitors: "Facilitator Link",
			link_admin: "Admin Link",
			link_presentation: "Slideshow Link",
			link_teams: "Teams Link",
			list_ingredients: "List of ingredients",
			link_favorite_images: "Link Favorite Images",
			total: "Total",
			remaining: "Remaining",
			round_ends: "Round ends in",
			round: "Round",
			play: "Play",
			resume: "Resume",
			pause: "Pause",
			pass_round: "Skip Round",
			time_ranking: "View time in ranking",
			results: "Results",
			add_team: "Add Team",
			add_teams: "Add Teams",
			order_points: "Sort ranking by points",
			add_challenges_first: "Add challenges first",
			general: "General",
			material: "Material",
			event_configuration: "Configure the event first",
			back: "Back",
			save: "Save",
			challenges: "Challenges",
			score_categories: "Score Categories",
			defense: "PITCH",
			presentation: "LOOKS",
			flavor: "FLAVOR",
			money: "MONEY",
			round_time: "Duration in minutes",
			tapas_time: "Cooking time",
			type: "Template",
			placeholder_type: "Select a type",
			setting_logo_replace_title: "Use template logo?",
			setting_logo_replace_message:
				"This event already has a logo. Keep the current one or use the logo configured by the client on the template?",
			setting_logo_keep_event: "Keep event logo",
			setting_logo_use_setting: "Use template logo",
			ingredient: "Ingredients",
			shop: "Shop",
			select_challenge: "Select a challenge",
			select_activity: "Select an activity",
			select_time_round: "Set a time per round",
			select_time_tapas: "Set a time to complete the tapas",
			select_categories: "Please select the categories",
			team_turn: "Team turn",
			type_election: "Type of election",
			round_election: "Round of election",
			round_total: "Total rounds",
			time_elaboration: "Preparation time",
			name_team: "Give the team a name",
			number_teams: "Number of teams",
			total_ingredients: "Total ingredients",
			extra_ingredients: "Extra ingredients",
			total_decoration: "Total decoration",
			extra_decoration: "Extra decoration",
			missing_ingredients: "Missing ingredients",
			list_download: "Download List",
			ingredients: "Ingredients",
			saved: "Saved",
			start_game: "Start Game",
			gm: "Facilitator",
			monitors: "Facilitators",
			monitors_visible: "Visible facilitators",
			monitors_hidden: "Facilitators hidden",
			readed: "Read",
			sent: "Sent",
			message_team: "Write a message to the team",
			message_all_teams: "The messages you write will be sent to all teams",
			your_message: "Your message",
			upload_image: "Upload image",
			add_emoji: "Add emoji",
			send_message: "Send message",
			all: "All teams",
			challenge: "Challenge",
			id_name: "Identifying Name",
			latitude: "Latitude",
			longitude: "Longitude",
			activations_radius: "Activation Radius",
			categories_points: "Score Categories",
			must_upper: "MANDATORY",
			first_upper: "FIRST",
			type_activation: "Activation Type",
			qr_upper: "QR",
			qr_code: "QR Code",
			location_upper: "LOCATION",
			first: "First",
			must: "Mandatory",
			add_challenges: "Add Challenges",
			select_latitude: "Select a latitude",
			select_longitude: "Select a longitude",
			placeholder_id_name: "Enter an identifying name",
			placeholder_template: "Select a template",
			put_duration: "Enter a duration",
			initial_position: "Initial position",
			not_template: "No template",
			template: "Template",
			placeholder_search_address: "Search for an address...",
			drag_drop_image: "Drag and drop an image here",
			or_click_upload: "or click to upload",
			no_image: "No image available",
			duration_seconds: "Duration (minutes)",
			duration_hours: "Duration in hours",
			duration_minutes: "Duration in minutes",
			categories: "Money challenge categories",
			time_action: "Set a time to complete the challenges",
			routes: "Routes",
			team_no_route: "There are teams without a route",
			changes_not_saved: "Changes not saved",
			route: "Route",
			order: "Order: ",
			name_route: "Name",
			placeholder_name_route: "Route name",
			event: "Event",
			select_setting: "Select a setting",
			initial_challenges: "Initial Challenges",
			time_higher_zero: "The time must be greater than 0",
			time_required: "The time per round is required",
			time_integer: "The time must be an integer",
			warning_template: "If you do not choose a template, you will have to create all the challenges manually.",
			add_teams_first: "Before adding materials you must add teams",
			round_time_minutes: "Time per round in minutes",
			acts: "Cases",
			placeholder_acts: "Select an Case",
			qr_codes: "QR codes",
			objects: "Objects",
			characters: "Suspects",
			type_game: "Game type",
			team_mode: "Team setup",
			alert_team_mode: "Select a team setup mode",
			team_mode_on_the_fly: "Teams on the fly",
			team_mode_on_the_fly_desc:
				"Players enter the lobby first and teams are created afterwards. This mode can work with locations (to group or identify players by table, room, city, office, etc.) or without locations (all players join and teams are created later).",
			team_mode_precreated: "Pre-made teams",
			team_mode_precreated_desc:
				"Uses the current Teaming App system where teams are already created before the game starts.",
			map_configuration: "Map configuration",
			finish_latitude: "Final latitude",
			finish_longitude: "Final longitude",
			map: "Map",
			init: "Start",
			finish: "Finish",
			online: "Online",
			presential: "In person",
			hybrid: "Hybrid",
			game_image: "Upload the image that will be seen by the players in their app",
			sets: "Sets",
		
			finish_position: "Final position",
			template_tooltip: "Select the base template whose content and settings will be copied into the new activity.",
			presential_tooltip: "Use this option when participants and facilitators are in the same venue. Music plays in the public screen.",
			online_tooltip: "Use this option when participants join remotely. Music plays in the player view.",
			type_game_tooltip: "Defines how challenges are unlocked: QR requires scanning codes and no map setup; Map uses locations and geolocation to activate them by proximity.",
			online_mode_tooltip: "The investigation runs without physical locations or QR codes. All suspects and objects start unlocked.",
			qr_upper_tooltip: "Teams unlock challenges by scanning QR codes. No map setup is required.",
			map_tooltip: "Teams use the map and geolocation to find the challenges.",
			initial_position_tooltip: "Defines the reference point around which all challenges are initially placed. It is also set as the activity finish point, although it can be changed later.",
			finish_position_tooltip: "It is set as the activity finish point, although it can be changed later.",
			all_teams: "All teams",
		},
		utq: {
			change_monitor: "Change Facilitator",
			round: "Round",
			ends: "Ends",
			start: "Start game",
			team_upper: "Team",
			position_upper: "Position",
			points_upper: "Points",
			team: "Team",
			placeholder_team: "Select a team",
			score: "Score",
			rate: "Rate",
			instructions_material: "Instructions and material",
			name_event: "Name the event",
			select_team: "Select a team",
			operation: "Operation",
			material: "Material"
		},
		tapas: {
			round_ends: "Round ends in",
			score_missing: "There are remaining challenges to score for the teams",
			start_challenges: "Start challenges",
			start_selection: "Start Ingredient Selection",
			start_elaboration: "Start Preparation Time",
			pass_round: "Skip Round",
			selecting_ingredients: "Selecting ingredients",
			pass_selection: "Skip selection",
			team_turn: "Team's turn",
			type_selection: "Type of selection",
			round_selection: "Selection round",
			round_total: "Total round",
			votes: "Votes",
			type_choice: "Type of choice",
			top_1: "Top 1",
			top_2: "Top 2",
			top_3: "Top 3",
			round: "Round",
			time_eleboration: "Elaboration time",
			start: "Start game",
			challenges: "Challenges",
			placeholder_challenge: "Select a challenge and press start",
			orders: "Orders",
			change_money: "Change money",
			shop: "Shop",
			challenges_results: "Challenge results",
			ingredient_selection: "Ingredient selection",
			winners: "Winners",
			placeholder_select_team: "Select a team",
			category: "Category",
			rate: "Rate",
			defense: "Defense",
			show: "Presentation",
			flavour: "Flavour",
			disponible_later: "Available later",
			change_main_ingredient: "Change Main Ingredient",
			challenges_done: "Challenges done"
		},
		ipad: {
			time_game: "Game time",
			start_game: "Start Game",
			add_delete_time: "Add/Delete Time",
			hide_ranking: "Hide Ranking",
			show_ranking: "Show Ranking",
			lock_challenges: "Lock Challenges",
			unlock_challenges: "Unlock Challenges",
			move_challenges: "Move challenges",
			challenges: "Challenges",
			clean_filters: "Clear filters",
			add_delete_points: "Adjust points",
			activate_challenge: "Activate Challenge",
			no_route: "No Route",
			instructor: "Instructor",
			player: "Player",
			team: "Team",
			points: "Points",
			challenges_done: "Completed Challenges",
			last_challenge: "Last Challenge",
			hour: "Time",
			must: "Mandatory",
			optionals: "Optional",
			status_not_started: "Not started",
			status_started: "Started",
			status_pending: "Uploading",
			status_done: "Completed",
			select_team_to_view_challenges: "Select a team to view their challenges"
		},
		action: {
			start: "Start game",
			next: "Next",
			time_game: "Game Time",
			start_game: "Start Game",
			add_delete_time: "Add/Remove Time",
			ranking: "Ranking",
			finish_game: "Finish Game",
			reactivate_game: "Reactivate Game",
			challenges: "Challenges",
			clean_filters: "Clear filters",
			team_filter: "Team Filter",
			challenge_filter: "Challenge Filter",
			add_delete_points: "Adjust points",
			add_delete_money: "Adjust money",
			activate_quiz: "Activate Money Challenge",
			ranking_normal: "Normal",
			ranking_coop: "Cooperative",
			ranking_both: "Both",
			ranking_hidden: "Hidden",
			ranking_slides: "Slides",
			activate_challenge: "Activate Challenge",
			show_videos: "Final Images",
			select_action: "Status",
			add_favorite: "Add to Favorites",
			delete_favorite: "Remove from Favorites",
			quizzes: "Quizzes",
			challenge_not_start: "No challenge has started yet",
			challenges_pick: "Challenges to pick up",
			challenges_return: "Challenges to return",
			challenges_material: "Challenge material",
			update_stock: "Modify stock",
			update_initial_stock: "Adjust initial stock",
			stock_upper: "STOCK: ",
			stock_initial_upper: "INITIAL STOCK: 2",
			stock: "Stock",
			team_upper: "Team",
			challenge_upper: "CHALLENGE",
			returned_upper: "RETURNED",
			delivered_upper: "DELIVERED",
			team: "Team",
			points: "Points",
			money: "Money",
			quizzes_done: "Completed quizzes",
			challenges_done: "Completed challenges",
			last_challenge: "Last challenge",
			material: "Item",
			save: "Save",
			material_to_pick: "Material to pick",
			stock_shop: "Shop stock",
			delivery: "Delivered",
			challenge_started: "Challenge started",
			error_start_challenge: "Error starting the challenge",
			challenge_flash: "Flash Challenge",
			next_challenge: "Force challenge",
			picked_challenges: "Picked challenges",
			fake_upload: "Fake upload",
			no_picked_challenges: "No picked challenges available",
		
			ranking_slides_tooltip: "Images that can be shown on the ranking screen to introduce or start the game.",
			stock_tooltip: "Default number of units available for purchase.",
		},
		cluedo_ai: {
			act_information: "Case information",
			characters: "Suspects",
			objects: "Objects",
			key_informations: "Key Information",
			chat: "Messages",
			ranking: "Ranking",
			configuration: "Options",
			start_game: "Start Game",
			next_act: "Next Case",
			add_points: "Add Points",
			add_time: "Add Time",
			give_object: "Give Object",
			give_information: "Give Information",
			questions: "Questions",
			team: "Team",
			points: "Points",
			objects_found: "Objects found",
			characters_found: "Suspects found",
			questions_answered: "Questions answered",
			position: "Position",
			add_delete_time: "Add/Delete Time",
			add_delete_points: "Adjust points",
			game_done: "Game finished. Go to the final meeting point.",
			participants_answer: "Participants' answer",
			correct_answer: "Correct answer",
			score: "Score",
			feedback: "Feedback",
			not_evaluated: "Not evaluated",
			edit_question: "Edit question",
			last_act: "Last case",
			evaluated: "Evaluated",
			confirm_start_game: "Are you sure you want to start the game?",
			confirm_next_act: "Are you sure you want to move to the next case?",
			confirm_last_act: "Are you sure you want to finish the last case?",
			no_chat: "There is no chat",
			pause_game: "Pause Game",
			resume_game: "Resume Game",

			character_name_alt: "Suspect name",
			object_name_alt: "Object name",
		},
		collabo: {
			double_materials_mode: "Double Materials Mode",
			material_multiplier_title: "Material multiplier",
			material_multiplier_configure: "Configure multiplier",
			material_multiplier_next_distribution: "It will apply to the next material distribution.",
			material_multiplier_updated: "Material multiplier updated successfully",
			material_multiplier_x1_hint: "Ideal for more than 30 pax",
			material_multiplier_x2_hint: "Ideal for 20 to 30 pax",
			material_multiplier_x3_hint: "Ideal for 10 to 20 pax",
			material_multiplier_x4_hint: "Less than 10 pax",
			double_materials_mode_on: "On",
			double_materials_mode_off: "Off",
			stage_give_material: "Give Material",
			select_team: "Select Team",
			select_material: "Select Material",
			enter_quantity: "Enter Quantity",
			give_material: "Give Material",
			material_given_success: "Material given successfully",
			material_given_error: "Error giving material",
			double_materials_mode_updated: "Double materials mode updated successfully",
			material: "Material",
			controls: "Controls",
			quantity: "Quantity",
			total_teams: "Total teams",
			total_rounds: "Total rounds",
			start_final_construction_round: "Start final construction round",
			final_construction_round_started: "Final construction round started",
			undo_final_construction_round: "Undo final construction round",
			confirm_start_final_construction_round: "Are you sure you want to switch to final construction mode?",
			confirm_undo_final_construction_round: "Are you sure you want to undo final construction mode?",
			final_construction_round_undone: "Final construction round undone",
			teams_list: "Team list",
			start_game: "Start game",
			no_teams: "There are no teams",
			game_started: "Game started successfully",
			game_start_error: "Error starting game",
			challenges_status: "Challenges Status",
			confirmed_teams: "Confirmed Teams",
			total_points: "Total Points",
			correct_answer: "Correct Answer",
			solution: "Solution",
			players_response: "Teams' response",
			team_removed_from_challenge: "Team removed from challenge",
			team_remove_from_challenge_error: "Error removing team from challenge",
			construction_phase_started: "Construction phase started",
			construction_phase_error: "Error starting construction phase",
			construction_phase: "Construction Phase",
			constructions_in_progress: "Constructions In Progress",
			no_constructions_in_progress: "No constructions in progress",
			building_type: "Building Type",
			leading_team: "Leading Team",
			helping_teams: "Helping Teams",
			completed_constructions: "Completed Constructions",
			no_completed_constructions: "No completed constructions",
			view_all_constructions: "View all",
			all_completed_constructions: "All completed constructions",
			all_constructions_ordered_by_last_done: "List ordered by most recently completed first.",
			constructions_of_type_ordered_by_last_done: "All constructions of this type, ordered by most recently completed first.",
			order: "#",
			remaining_materials: "Remaining Materials",
			construction_phase_finished: "Construction phase finished",
			construction_phase_finish_error: "Error finishing construction phase",
			team: "Team",
			position: "Position",
			points: "Points",
			chat: "Messages",
			ranking: "Ranking",
			configuration: "Options",
			go_to_construction: "Go to Construction Phase",
			finish_construction_phase: "Finish Construction Phase",
			show_teams: "Show Teams",
			hide_teams: "Hide Teams",
			unsaved_changes: "You have unsaved changes",
			save: "Save",
			number_of_challenges: "Sets of challenges",
			link_teams: "Link Teams",
			link_monitors: "Link Facilitators",
			link_staff: "Staff Link",
			add_team: "Add Team",
			add_teams: "Add Teams",
			materials: "Materials",
			no_materials: "No materials",
			constructions: "Constructions",
			no_constructions: "No constructions",
			challenges: "Material challenges",
			no_challenges: "No challenges",
			round_time: "Challenges round time  in minutes",
			minutes: "Minutes",
			round_time_placeholder: "Enter round time in minutes",
			challenge_time: "Construction round time in minutes",
			challenge_time_placeholder: "Enter construction time in minutes",
			game_mode: "Game Mode",
			teams: "Teams",
			individual: "Individual",
			ranking_title: "City Title",
			ranking_title_placeholder: "Title shown on the public ranking screen",
			quantity_by_team: "Quantity per team",
			enter_quantity_by_team: "Enter quantity per team",
			total: "Total",
			player_answer: "Player's answer",
		
			ranking_title_tooltip: "Title displayed on the public ranking screen.",
			individual_tooltip: "Each participant plays on their own phone and joins the activity using a QR code.",
			teams_tooltip: "Participants play in fixed teams and share one tablet throughout the activity.",
			number_of_challenges_tooltip: "Defines how many complete challenge sets will be used. For events with more than 50 participants.",
		},
		common_sense: {
			controls: "Controls",
			total_teams: "Total teams",
			no_teams: "There are no teams",
			start_game: "Start game",
			pause_game: "Pause Game",
			resume_game: "Resume Game",
			show_final_ranking: "Show final ranking",
			game_final_ranking: "Final ranking",
			game_status_final_ranking: "Final ranking",
			final_ranking_shown: "Final ranking shown",
			game_resumed: "Game resumed",
			game_running: "Game running",
			game_paused: "Game paused",
			teams_list: "Team list",
			game_started: "Game started successfully",
			game_start_error: "Error starting game",
			ranking: "Ranking",
			challenge_ranking: "Challenge ranking",
			ranking_your_team: "Your team",
			ranking_leaderboard: "Leaderboard",
			ranking_points_abbr: "pts",
			ranking_number_header: "#",
			team: "Team",
			position: "Position",
			points: "Points",
			phase: "Phase",
			roulette: "Roulette",
			roulette_stage_title: "Team roulette challenges",
			select_challenge: "Select a challenge",
			challenge_started_times: "({count}×)",
			roulette_start: "Start",
			public_rules_show: "Show rules on public screen",
			public_rules_hide: "Hide rules on public screen",
			roulette_hint: "Select a challenge and start the roulette.",
			flow_mode: "Flow mode",
			flow_mode_hint: "Order challenges and save so the instructor only needs to press Next.",
			flow_instructor_hint: "Enable Flow to advance with Next. You can adjust the order and boosters before continuing if last-minute changes are needed.",
			flow_event_hint: "Define the flow order for this event. You can still change it live if needed.",
			flow_remove_challenge: "Remove challenge from flow",
			flow_restore_all: "Restore all",
			flow_restore_selected: "Use selected challenges",
			flow_position: "Position",
			flow_no_booster: "No booster",
			flow_configure: "Configure Flow",
			flow_enabled: "Flow active",
			flow_disabled: "Flow inactive",
			flow_challenge_progress: "Game {current} of {total}",
			skip_flow_challenge: "Skip challenge",
			skip_flow_challenge_confirm:
				"Are you sure you want to skip this challenge? If it is in progress it will go to the main screen; if it has not started yet it will be omitted from the flow without being shown to players.",
			skip_flow_challenge_done: "Challenge skipped",
			next: "Next",
			advance_phase: "Advance phase",
			finish_challenge: "Finish challenge",
			finish_ranking: "Finish ranking",
			reset_to_waiting_challenge: "Back to challenge pick",
			reset_to_waiting_challenge_confirm:
				"You will return to the waiting phase (roulette) without showing the challenge ranking or completing pending rounds. Points already awarded in earlier rounds are kept.",
			reset_to_waiting_challenge_done: "Phase reset — you can pick a new challenge",
			add_substract_points: "Add / subtract points",
			points_hint: "Use negative values to subtract.",
			boosters: "Boosters",
			booster_half_time: "Half time",
			booster_points_x2: "Double points",
			select_booster: "Select a booster",
			apply_booster: "Apply booster",
			roulette_challenge_image_alt: "Challenge image: {name}",
			roulette_challenge_default: "Challenge {id}",
			roulette_show_badge: "CHALLENGE",
			public_no_challenges: "No challenges are configured for this event.",
			public_loading: "Loading…",
			public_waiting_game: "Waiting for the host to start the game.",
			public_waiting_challenge: "When the host draws a challenge, the roulette will play here.",
			player_menu_play: "Game",
			player_menu_settings: "Settings",
			instructor_menu_controls: "Game controls",
			instructor_menu_ranking: "Ranking",
			instructor_menu_settings: "Options",
			ranking_team_fallback: "Team {id}",
			public_challenge_rules: "Challenge rules",
			public_no_rules_text: "No rules text was configured for this challenge.",
			challenge_play_subphase: "Challenge step {n}",
			in_challenge_phase_waiting: "Waiting for challenge",
			in_challenge_phase_rolling: "Roulette",
			in_challenge_phase_showing_rules: "Showing rules",
			in_challenge_phase_playing: "Challenge in play",
			in_challenge_phase_result: "Challenge result",
			in_challenge_phase_ranking: "Ranking",
			in_challenge_phase_unknown: "Unknown phase",
			challenge_subphase_progress: "{current} of {total}",
			challenge_subphase_of: "of",
			phase_code: "Phase {code}",
			challenge_no_active: "No active challenge selected.",
			challenge_fair_prize_play: "Fair prize challenge — play screen",
			challenge_quiz_play: "Quiz challenge — play screen",
			challenge_timeline_play: "Timeline challenge — play screen",
			timeline_no_rounds: "No timeline rounds configured for this challenge.",
			timeline_question_heading: "Order the steps",
			timeline_order_hint: "Order the cards. You can change the order until time runs out.",
			timeline_order_context_aria: "How to order the timeline",
			timeline_position: "{n}",
			timeline_question_label: "Question {n}",
			timeline_timer_aria: "Time remaining",
			phase_timer_question: "Time",
			phase_timer_results: "Time",
			timeline_steps_aria: "Steps to order",
			timeline_submit_answer: "Submit order",
			timeline_answer_submitted: "Order submitted",
			timeline_result_intro: "Your order and points per card.",
			timeline_result_round_label: "Points this round",
			timeline_result_no_movement: "You did not reorder any cards.",
			timeline_result_total: "+{n} pts",
			timeline_result_points: "+{n}",
			timeline_result_correct: "Correct",
			timeline_result_semi: "Close",
			timeline_result_wrong: "Wrong",
			timeline_result_should_be: "Correct order: {n}",
			timeline_public_result_hint: "Correct sequence order.",
			timeline_public_team_hits: "Team hits: {n}",
			timeline_public_perfect_order: "Perfect order",
			timeline_public_perfect_score: "({correct}/{total})",
			quiz_no_questions: "No quiz questions configured for this challenge.",
			quiz_question_heading: "Question",
			quiz_answers_aria: "Answer options",
			quiz_select_answer: "Select your answer",
			quiz_submit_answer: "Submit answer",
			quiz_answer_submitted: "Answer submitted",
			quiz_change_until_time_end: "You can change your answer until time runs out.",
			quiz_result_teams_pct: "{count}/{total} · {pct}%",
			quiz_waiting_play: "Wait for the instructor to start the challenge round.",
			fair_prize_question_heading: "Question",
			fair_prize_slider_aria: "Price range slider",
			fair_prize_range_from: "From",
			fair_prize_range_to: "To",
			fair_prize_your_guess: "Your estimate",
			fair_prize_select_value: "Drag the slider to pick your best guess",
			fair_prize_submit_answer: "Submit answer",
			fair_prize_answer_submitted: "Answer submitted",
			fair_prize_change_until_time_end: "You can change your estimate until time runs out.",
			fair_prize_no_questions: "No fair prize rounds configured for this challenge.",
			fair_prize_correct_answer: "Correct answer",
			fair_prize_result_your_guess: "Your estimate",
			fair_prize_result_no_adjustment: "You did not adjust your estimate.",
			fair_prize_legend_correct: "Correct",
			fair_prize_legend_your_team: "Your team",
			fair_prize_legend_others: "Others",
			fair_prize_all_team_answers: "All team answers",
			fair_prize_no_team_answers: "No team answers yet",
			fair_prize_teams_count: "{n} teams",
			fair_prize_teams_label: "teams",
			quiz_correct_answer: "Correct answer",
			challenge_result_badge: "Result",
			rules_fair_prize_badge: "Fair prize challenge",
			rules_timeline_badge: "Timeline challenge",
			rules_quiz_badge: "Quiz challenge",
			rules_section_kicker: "Challenge",
			rules_quiz_type: "Multiple choice",
			rules_timeline_type: "Order",
			rules_fair_prize_type: "Estimation",
			rules_quiz_intro:
				"{count} questions. Answer before time runs out — faster correct answers earn more points for your team.",
			rules_timeline_intro:
				"{count} ordering rounds. Put the steps in the right sequence before time runs out.",
			rules_fair_prize_intro:
				"{count} estimation rounds. Guess the closest value before time runs out.",
			rules_quiz_demo_title: "Tap an answer",
			rules_quiz_demo_hint:
				"Tap the colored card you think is correct. You can change your answer until time runs out.",
			rules_timeline_demo_title: "Drag to order",
			rules_timeline_demo_hint:
				"Hold each card and drag it up or down until the sequence is correct. You can change the order until time runs out.",
			rules_timeline_step_a: "Step A",
			rules_timeline_step_b: "Step B",
			rules_timeline_step_c: "Step C",
			rules_fair_prize_demo_title: "Adjust the number",
			rules_fair_prize_demo_hint:
				"Slide the control or use the − and + buttons to fine-tune your estimate. The closest guess wins.",
			player_challenges_heading: "Your challenges",
			player_challenges_subtitle: "Pick a challenge when the host activates it on the roulette to play.",
			player_challenge_active_now: "Active now",
			player_challenge_not_active: "This challenge is not active yet. Wait for the host to draw it on the roulette.",
			player_challenge_open_play: "Play now",
			player_challenge_view_details: "View details",
			player_back_to_challenges: "All challenges"
		},
	
		forms: {
			please_input: "Enter an amount",
		
			please_select: "Select an option",
			please_select_filter: "Select a filter",
		},
	},
	errors: {
		required: "This field is required",
		invalid_email: "The email is not valid",
		invalid_url: "The URL is not valid",
		invalid_number: "The number is not valid",
		field_invalid: "Field {field} is incorrect",
		connection: "Could not connect to the server",
		unauthorized: "You do not have permission to perform this action",
		not_found: "The record was not found",
		conflict: "A record with this data already exists",
		server: "A server error occurred"
	},
	messages: {
		join_game_success: "You have joined the game successfully",
		success: "Success",
		download_completed: "Download completed",
		error: "Error",
		error_downloading: "Could not download the file",
		round_pass: "Round skipped",
		canceled: "Canceled",
		deleted: "Deleted",
		updated: "Updated",
		added: "Added",
		monitor_added: "Facilitator added successfully",
		monitor_updated: "Facilitator updated successfully",
		monitor_not_added: "Could not add the facilitator",
		score_ok: "Score sent successfully",
		score_not_ok: "Could not send the score",
		score_add: "Add a score",
		select_team: "Select a team",
		team_error: "Could not add the team",
		team_correctly: "Team {msg} added correctly",
		incorrect_fields: "There are incorrect fields in the form",
		tapas_succesfull_updated: "Tapas War activity updated successfully",
		tapas_not_succesfull_updated: "Could not update the Tapas War activity",
		tapas_succesfull_added: "Tapas War activity added successfully",
		tapas_not_succesfull_added: "Could not add the Tapas War activity",
		select_passed: "Selection skipped",
		link_copied: "Link copied",
		votes_deleted: "Votes deleted successfully",
		votes_not_deleted: "Could not delete the votes",
		money_updated: "Money updated",
		teams_added: "Teams added successfully",
		game_started: "Game Started",
		deleted_ok: "Deleted successfully",
		deleted_not_ok: "Could not delete",
		updated_not_ok: "Could not update",
		error_generating_pdf: "Error generating PDF",
		select_challenge: "Select a challenge",
		challenges: "Challenges",
		template: "Template",
		ipad_hunt_not_succesfull_added: "Could not add the Ipad Hunt activity.",
		challenge_activated: "Challenge Activated",
		points_updated: "Points Updated",
		time_updated: "Time Updated",
		correctly_scored: "Scored correctly",
		incorrectly_scored: "Could not score correctly",
		team: "Team",
		action_updated_ok: "Action Challenge activity updated successfully",
		action_updated_not_ok: "Could not update the Action Challenge activity",
		action_added_ok: "Action Challenge activity added successfully",
		action_added_not_ok: "Could not add the Action Challenge activity",
		route_created: "Route Created",
		route_deleted: "Route Deleted",
		route_saved: "Route Saved",
		saved: "Saved",
		select_category: "Select a category",
		must_select: "You must select top1 and top 2",
		vote_sent: "Vote sent",
		vote_error: "Error voting",
		correct_score: "Scored Correctly",
		incorrect_score: "Could not score correctly",
		game_reactivated: "Game Reactivated",
		game_finished: "Game Finished",
		write_quesiton: "Write a question",
		event_deleted: "Event deleted",
		select_activity: "You must select the activity",
		event_created: "Event created",
		event_updated: "Event edited",
		event_not_created: "Event could not be created",
		write_question: "Write a question",
		utq_updated: "Ultimate Team Quest activity updated successfully",
		utq_not_updated: "Could not update the Ultimate Team Quest activity",
		url_copied: "URL copied",
		url_error: "Error copying the URL",
		error_deleting_event: "Could not delete the event",
		reopened: "Reopened",
		finished: "Finished",
		cancelled: "Cancelled",
		closed_booking: "Booking Closed",
		canceled_booking: "Booking Canceled",
		file_removed: "File removed",
		upload_file: "Upload file",
		file_uploaded: "File uploaded",
		error_upload: "Failed to upload the file",
		no_id_model: "You must save the form before uploading files",
		no_files_readonly: "There are no files to download at the moment.",
		favorite_challenge_added: "Favorite challenge added",
		favorite_challenge_removed: "Favorite challenge removed",
		next_act: "Next Case",
		added_points: "Added Points",
		added_time: "Added Time",
		given_object: "Given Object",
		given_information: "Given Information",
		game_paused: "Game paused",
		game_resumed: "Game resumed"
	},
	erp: {
		booking: {
			calendar: {
				calendar: "Calendar",
				filters: "Filters",
				calendar_filters: "Calendar filters",
				production_details: "Production details",
				configure_fields: "Configure fields",
				crm_id: "CRM ID",
				pax: "Pax",
				language: "Language",
				fundae: "FUNDAE",
				staff_number: "Number of facilitators",
				teams_number: "Number of teams",
				bookings: "Bookings",
				budgets: "Quotes",
				vendedor: "Seller",
				produccion: "Production",
				select_vendedor: "Select Seller",
				select_produccion: "Select Production",
				gamemasters: "Facilitators",
				accepted: "ACCEPTED",
				to_check: "TO CHECK"
			},
			reservation: "Booking",
			client_link: "Client link",
			changes_pending: "Changes pending validation",
			changes_sent_title: "Changes saved",
			changes_sent_detail: "Your changes have been saved and sent successfully. They are now pending validation.",
			changes_sent_no_changes: "There were no new changes to send.",
		},
		user_settings: {
			title: "User Settings",
			change_password: "Change Password",
			new_password: "New Password",
			enter_new_password: "Enter the new password",
			confirm_password: "Confirm Password",
			confirm_new_password: "Confirm the new password",
			change_password_button: "Change Password",
			change_language: "Change Language",
			language: "Language",
			select_language: "Select a language",
			change_language_button: "Change Language",
			password_required: "Please enter the new password",
			password_min_length: "The password must be at least 8 characters",
			confirm_password_required: "Please confirm the new password",
			passwords_not_match: "The passwords do not match",
			password_changed_success: "Password changed successfully.",
			password_change_error: "Error changing the password. Please try again.",
			form_errors: "Please correct the errors in the form.",
			spanish: "Spanish",
			english: "English",
			language_required: "Please select a language",
			language_updated_success: "Language updated successfully.",
			language_update_error: "Error updating the language. Please try again.",
			select_valid_language: "Please select a valid language."
		},
		configuration: {
			organization: {
				link_app: "Application link",
				testing_link: "Online Games Testing Link",
				testing_link_description: "Share this link with clients so they can test their connection and device setup before the event.",
				open: "Open",
				organization_url: "Organization URL",
				copy: "Copy",
				users: "Users",
				create_new_user: "Create New User",
				edit_user: "Edit User",
				name: "Name",
				enter_name: "Enter the name",
				role: "Role",
				cancel: "Cancel",
				save: "Save",
				email: "Email",
				enter_email: "Enter the email",
				password: "Password",
				enter_password: "Enter the password",
				confirm_password: "Confirm Password",
				confirm_password_placeholder: "Confirm the password",
				create: "Create",
				confirm_deletion: "Confirm deletion",
				delete_user_confirmation: "Are you sure you want to delete user {name}?",
				delete: "Delete",
				organization_qr_code: "Organization QR Code",
				administrator: "Administrator",
				facilitator: "Facilitator",
				edit: "Edit",
				actions: "Actions",
				url_copied: "URL copied to clipboard",
				user_updated: "User updated successfully",
				error_updating_user: "Error updating user",
				user_created: "User created successfully",
				error_creating_user: "Error creating user",
				user_deleted: "User deleted successfully",
				error_deleting_user: "Error deleting user",
				select_role: "Select a role",
				slack_configuration: "Slack configuration",
				slack_install_description: "Install the Slack application to receive event notifications.",
				slack_connected: "Slack connected",
				slack_not_connected: "Slack not connected",
				event_notifications_channel: "Event notifications channel",
				staff_notifications_channel: "Staff notifications channel",
				select_channel: "Select a channel",
				refresh_channels: "Refresh channels",
				save_slack_config: "Save Slack configuration",
				slack_config_saved: "Slack configuration saved",
				error_saving_slack_config: "Error saving Slack configuration",
				channels_refreshed: "Channels refreshed",
				error_refreshing_channels: "Error refreshing channels",
				initial_position: "Initial Position for Events",
				initial_position_label: "Initial location",
				search_location: "Search location...",
				error_loading_places: "Error loading places service",
				available_languages: "Available languages",
				select_languages: "Select languages",
				default_language: "Default language",
				select_default_language: "Select the default language",
				at_least_one_language_required: "At least one language must be selected",
				make_all_pdfs: "Generate all PDFs",
				make_all_pdfs_cooldown:
					"PDF generation is already in progress. You can start again 45 minutes after the last run.",
				make_all_pdfs_started: "PDF generation has been started.",
				make_all_pdfs_error: "Could not start PDF generation. Please try again.",
				personalization: "Personalization",
				monitor_info: "Monitor information",
				field_label: "Field label",
				field_type: "Field type",
				field_options: "Field options (comma separated)",
				visible_to_staff: "Visible to staff",
				required: "Required",
				active: "Active",
				add_field: "Add field",
				booking_defaults: "Booking default fields",
				booking_default_field: "Booking field",
				booking_default_value: "Default value",
				booking_default_files: "Template files",
				booking_default_save_first_upload: "Save the configuration before uploading template files.",
				booking_default_json_hint: "Enter valid JSON (array or object).",
				fundae_enabled: "Enable FUNDAE fields",
				contracts_enabled: "Enable booking contracts",
				contracts: "Contracts",
				booking_custom_fields: "Booking custom fields",
				booking_custom_fields_hint: "These fields appear on the booking and can be used as contract variables.",
				contract_template: "Contract template",
				contract_template_hint: "Write the contract and insert booking variables or client fields wherever you want. Client fields do not appear on their own: you must insert them into the text.",
				insert_booking_variable: "Variable or field",
				insert_variable: "Insert variable",
				add_client_field: "Create client field",
				client_field_button_tooltip: "Creates a field the client will fill in and inserts it at the cursor in the contract.",
				client_field_tooltip: "Help text (tooltip)",
				contract_client_fields: "Client fields",
				contract_client_fields_hint: "Fields the client fills in. Create them here and insert their variable into the contract text wherever you want.",
				contract_template_expand: "Show contract text",
				contract_template_collapse: "Minimize contract text",
				client_field_option_prefix: "Client",
				signing_fields_title: "Signing fields",
				signing_fields_hint: "Name and signature are always required when signing. Here you only add extra text fields (e.g. ID number).",
				signing_field_required: "Required",
				add_signing_text_field: "Add text field",
				signing_type_name: "Name",
				signing_type_signature: "Drawn signature",
				signing_type_text: "Text",
				signature_template_title: "Signature paragraph",
				signature_template_hint: "Text appended to the contract when the client signs. Insert signature variables and signing fields.",
				insert_signature_variable: "Signature variable",
				insert_into_signature: "Insert into signature paragraph",
				signature_var_signer_name: "Signer name",
				signature_var_signed_datetime: "Date and time",
				signature_var_signed_date: "Date",
				signature_var_signed_time: "Time",
				signature_var_signature_image: "Signature image",
				signature_var_signed_by_label: "“Signed by” label (booking language)",
				signature_var_date_label: "“Date and time” label (booking language)",
				signature_var_company_signer_name: "Company signer name",
				signature_var_company_signature_image: "Company signature",
				company_signature_title: "Company signature",
				company_signature_hint: "Your company name and signature. They are added automatically to every signed contract.",
				company_signer_name: "Company signer name",
				company_signature_draw: "Draw company signature",
				company_signature_clear: "Remove company signature",
				booking_field_type_text: "Text",
				booking_field_type_textarea: "Long text",
				booking_field_type_number: "Number",
				booking_field_type_date: "Date",
				booking_field_type_select: "Select",
				booking_field_type_checkbox: "Checkbox",
				notifications: "Notifications",
				notifications_channels: "Channels",
				notifications_channel_email: "Email",
				notifications_channel_whatsapp: "WhatsApp",
				notifications_list: "Notifications",
				notifications_enabled: "Enabled",
				notifications_channels_for_event: "Send via",
				notifications_trigger_monitor_activity_offer: "When a facilitator receives an activity offer",
				notifications_trigger_monitor_accept_reject: "When a facilitator accepts or rejects an activity",
				notifications_whatsapp_inbound: "WhatsApp auto-reply",
				notifications_whatsapp_inbound_hint:
					"Text sent when a facilitator writes to the WhatsApp number.",
				notifications_event_list: "Event notifications",
				notifications_event_hint:
					"Scheduled alerts relative to the event start, from 3 days before to 3 days after.",
				notifications_event_add: "Add notification",
				notifications_event_edit: "Edit notification",
				notifications_event_name: "Name",
				notifications_event_name_required: "Each event notification needs a name.",
				notifications_event_when: "When",
				notifications_event_when_before: "Before the event",
				notifications_event_when_after: "After the event",
				notifications_event_days: "Days",
				notifications_event_hours: "Hours",
				notifications_event_minutes: "Minutes",
				notifications_event_message: "Text",
				notifications_event_recipients: "Recipients",
				notifications_event_recipient_sales_responsible: "Sales manager",
				notifications_event_recipient_production_responsible: "Production manager",
				notifications_event_recipient_responsible_monitor: "Lead facilitator",
				notifications_event_recipient_monitors: "Facilitators",
				field_type_text: "Text",
				field_type_select: "Select",
				field_type_multiselect: "Multi select",
				field_type_checkbox: "Checkbox",
				field_type_phone_communications: "Communications phone"
			},
			credit_consumption: {
				title: "Credit consumption",
				subtitle: "Organization credit usage, billing totals, and payment status.",
				entries: "Entries",
				total_credits: "Total credits",
				paid_amount: "Paid amount",
				pending_amount: "Pending amount",
				filters: "Filters",
				date_from: "Date from",
				date_to: "Date to",
				activity_type: "Activity type",
				payment_status: "Payment status",
				apply: "Apply",
				consumption_details: "Consumption details",
				rows_count: "{count} rows",
				col_date: "Date",
				col_event: "Event",
				col_activity: "Activity",
				col_credits: "Credits",
				col_unit_price: "Unit price",
				col_amount: "Amount",
				col_paid: "Paid",
				status_paid: "Paid",
				status_pending: "Pending",
				empty_state: "No credit consumption found for current filters.",
				filter_all: "All",
				filter_paid: "Paid",
				filter_pending: "Pending",
				all_activities: "All activities",
				activity_fallback: "Activity {id}",
				load_failed: "Failed to load credit consumption."
			}
		}
	},
	events: {
		active_events: "Active events",
		event: "Event",
		game: "App",
		day: "Date",
		actions: "Actions",
		view_event: "View event",
		enter: "Enter",
		finish: "Finish",
		reopen: "Reopen",
		delete_event: "Delete event",
		are_you_sure: "Are you sure?",
		accept: "Accept",
		cancel: "Cancel",
		no_content: "No content",
		no_content_in_activity: "There is no content in this activity",
		edit: "Edit",
		download: "Download",
		delete: "Delete",
		search_name: "Search by name..."
	},
	bookingmedia: {
		uploadImages: "Upload images",
		downloadImages: "Download images",
		imageUploaded: "Image uploaded",
		imageRemoved: "Image removed",
		imagesUploaded: "Image uploaded",
		uploadFailed: "Error uploading the image",
		uploadAllFailed: "Could not upload any images. Check your connection and try again.",
		uploadPartialSuccess: "Uploaded {success} of {total} images. {failed} could not be uploaded.",
		uploadRetrying: "Retrying ({attempt}/{max})",
		notSavedForm: "You must save the reservation before uploading images",
		uploadedImage: "Booking image",
		viewImage: "View full size image",
		removeImage: "Remove image",
		removeFailed: "Could not remove the image",
		noImages: "No photos yet",
		noImagesHint: "Upload images to document this booking",
		photoCount: "{count} photo(s)",
		loadMorePhotos: "Load more ({count} remaining)",
		noContent: "No images to download"
	},
	favoritePhotos: {
		title: "Favorite photos",
		subtitle: "Saved booking photos, filterable by booking and activity",
		addFavorite: "Add to favorites",
		removeFavorite: "Remove from favorites",
		selectActivity: "Assign activity",
		selectActivityHint: "The first booking activity is selected by default. You can search and pick any activity from the catalog.",
		searchActivity: "Search activity...",
		searchBooking: "Search booking...",
		noFilterResults: "No results",
		previousPhoto: "Previous photo",
		nextPhoto: "Next photo",
		downloadError: "Could not download the image",
		selectActivityPlaceholder: "Select an activity",
		noActivitySearchResults: "No activities found",
		noActivitiesCatalog: "No activities in the catalog",
		noActivitiesInBooking: "This booking has no linked activities. The photo will be saved without an activity.",
		activity: "Activity",
		noActivity: "No activity",
		added: "Photo added to favorites",
		removed: "Photo removed from favorites",
		addError: "Could not add to favorites",
		removeError: "Could not remove from favorites",
		filterBooking: "Booking",
		filterActivity: "Activity",
		allBookings: "All bookings",
		allActivities: "All activities",
		applyFilters: "Filter",
		empty: "No favorite photos yet",
		loadingMore: "Loading more photos…",
		allPhotosLoaded: "All {count} photos are shown"
	},
	client: {
		budgets: "Quotes",
		bookings: "Bookings",
		billed: "Billed"
	},
	cluedo_ai: {
		cluedo_ai_player: {
			scan_qr_code: "Scan QR",
			key_information: "Key information",
			no_key_information: "No key information",
			objects: "Objects",
			key_information_missing: "Key information missing",
			characters: "Suspects",
			game_intro: "Case introduction",
			question: "Question",
			game_finished: "Game finished",
			questions_modified: "Unsaved answers",
			init_conversation: "Send a message to start the conversation with {character_name}",
			interrogate: "Interrogate",
			explore: "Explore",
			view_intro: "View introduction",
			send_answer: "Send answer",
			conclusions: "Conclusions",
			not_started: "The game hasn't started yet",
			updated: "Responses updated",
			answers_not_sent: "Answers could not be sent",
			answers_sent: "Answers sent",
			new_object_unlocked: "New object unlocked",
			new_character_unlocked: "New character unlocked",
			model_3d: "3D Model",
			answer_placeholder: "Answer...",
			found_object: "YOU HAVE FOUND AN OBJECT",
			found_character: "YOU HAVE FOUND A CHARACTER",
			error_invalid_qr: "Invalid QR code",
			error_wrong_case_title: "Wrong case",
			error_wrong_case_message: "This QR code belongs to another case. Only QR codes from the current live case can be scanned.",
			evaluated: "Evaluated the answers",
			no_answer: "No answer",
			upload_team_picture: "Upload team picture",
			no_picture: "No team picture",
			game_paused: "The game is paused, wait for the facilitator to resume it.",
			voice_record: "Speak (tap to record, tap again to transcribe)",
			voice_stop: "Stop recording and transcribe",
			voice_listening: "Listening…",
			voice_transcribing: "Transcribing audio…",
			voice_error_microphone_unavailable: "Microphone is not available on this device.",
			voice_error_microphone_denied: "Microphone permission denied.",
			voice_error_empty_recording: "No audio was recorded.",
			voice_error_empty_transcript: "Could not understand the audio.",
			voice_error_transcription_failed: "Could not transcribe audio. Please try again."
		}
	},
	collabo: {
		player_collabo: {
			seconds_to_show_error_modal: "Wait {seconds} seconds",
			error: "Error",
			incorrect_answer: "Incorrect answer. Please try again.",
			correct: "Correct",
			correct_answer: "Correct answer",
			last_buildings: "Last Buildings",
			buildings: "Buildings",
			join_challenge: "I'm in {challenge_name}",
			go_zone: "GO TO THE ZONE OF THE CHALLENGE <span class='text-primary'>{challenge_name}</span> TO START.",
			confirm_join_challenge: "Are you sure you are in the roll-up of <span class='text-primary'>{challenge_name}</span>?",
			players_joined: "Players",
			cancel: "Cancel",
			confirm_join: "Confirm",
			points_added: "Points added successfully",
			points_add_error: "Error adding points",
			challenge_joined: "Challenge joined successfully",
			challenge_join_error: "Error joining challenge",
			construction_in_progress: "Construction In Progress",
			material_needed: "Material Needed",
			delete_construction: "Delete Construction",
			cancel_construction: "Cancel Construction",
			join_construction: "QR to join",
			material_in_construction: "Material in construction:",
			available: "Available",
			in_construction: "In Construction",
			player_join: "Player Join",
			helpToBuild: "Help to Build",
			build: "Build",
			not_enough_materials: "Not Enough Buildings",
			build_construction: "Build Construction",
			build_construction_description: "Do you want to start building this construction?",
			new_material_received: "New Material Received",
			accept: "Accept",
			join_construction_description: "Scan the QR code to join this construction",
			delete_construction_description: "Are you sure you want to delete this construction?",
			delete: "Delete",
			cancel_construction_description: "Are you sure you want to cancel helping with this construction?",
			construction_finished: "Construction Finished",
			construction_finished_description: "The construction has been completed!",
			success_construction: "Success Construction",
			building_id: "Building ID",
			built_by: "BUILT BY",
			just_now: "Just now",
			some_minutes_ago: "{miunutes} minutes ago",
			more_than_hour_ago: "More than an hour ago",
			minute_ago: "MIN",
			minutes_ago: "MIN",
			hour_ago: "H",
			hours_ago: "H",
			day_ago: "DAY",
			days_ago: "DAYS",
			material_accepted: "Material accepted successfully",
			material_accept_error: "Error accepting material",
			material_added: "Material added successfully",
			material_add_error: "Error adding material",
			construction_canceled: "Construction canceled successfully",
			construction_cancel_error: "Error canceling construction",
			construction_deleted: "Construction deleted successfully",
			construction_delete_error: "Error deleting construction",
			construction_started: "Construction started successfully",
			construction_error: "Error starting construction",
			enter_number: "Enter Number",
			submit: "Submit",
			select_color: "Select Color",
			select_color_first: "Please select a color first",
			saving: "Saving...",
			no_recipe: "No recipe available",
			your_components: "Your Components",
			component_updated: "Component updated successfully",
			matrix_updated: "Matrix updated successfully",
			matrix_update_error: "Error updating matrix",
			your_resources: "Your Resources",
			or_enter_code: "Or enter the code:",
			enter_3_letters: "Enter 3 letters",
			validate_code: "Validate Code",
			invalid_code: "Invalid code",
			code_not_found: "The code does not correspond to any available construction",
			code_label: "Code:",
			objective_done: "Objective completed",
			teams_in_construction: "Teams in construction",
			participants_in_construction: "Participants in construction",
			leading_team: "Leading"
		}
	},
	qr_scanner: {
		camera_permission_denied: "ERROR: Camera permission denied",
		no_camera_found: "ERROR: No camera found on device",
		unable_to_start_camera: "ERROR: Unable to start camera"
	},
	map: {
		search_address: "Search for an address...",
		locate_button: "Center map",
		switch_map_type: "Change map type"
	},
	musicalBingo: {
		staff: {
			skip_challenge: "Skip challenge",
			controls: "Controls",
			status: "Status",
			start_game: "Start game",
			waiting_game: "Waiting game",
			waiting_set: "Selecting Bingo",
			next_step: "Next step",
			start_bingo: "Start Bingo",
			game_start_soon: "Bingo ready to start",
			start_bingo_public: "Start Bingo",
			playing_song: "Playing song",
			result_song: "Song result",
			pause_song: "Pause song",
			resume_song: "Resume song",
			repeat_song: "Repeat song",
			song_result: "Song result",
			playing_challenge: "Playing challenge",
			remaining_time: "Remaining time",
			team_answers: "Team answers",
			correct_answers: "Correct answers",
			players: "Players",
			song: "Song",
			next_image: "Next image",
			bingo_select: "Select Bingo",
			final_ranking: "Show Ranking",
			final_photo: "Show Pictures",
			bingo_done: "Bingos finished",
			finish_game: "Finish bingo",
			bingo_finished: "Bingo finished",
			stop_bingo: "Stop bingo",
			live_view: "Live view",
			volume_up: "Volume +",
			volume_down: "Volume -",
			command_send: "Command sent",
			next_step_send: "Next step sent",
			winner_team: "Winning team",
			challenge_explaining: "Explaining the challenge",
			song_challenge: "Song of the challenge",
			song_post_challenge: "Song of the post challenge",
			exclude_teams: "Teams that should not win this bingo",
			exclude_teams_placeholder: "Select teams (optional)",
			exclude_teams_all_error: "At least one team must be allowed to win"
		},
		public_view: {
			photo_saved: "Photo saved",
			re_take_photo: "Re-take photo",
			select_option: "Select the most voted option",
			quiz_results: "Quiz results",
			challenge_results: "Challenge results",
			waiting_game: "Waiting for game",
			selecting_bingo: "Selecting Bingo",
			bingo_start_soon: "The Bingo will start soon",
			playing: "Playing song",
			ranking: "Ranking",
			seconds: "seconds",
			points: "points",
			answer_sent: "Answer sent",
			answer_not_sent: "Answer could not be sent",
			send_answer: "Send answer",
			remaining_time: "Remaining time",
			team_answers: "Team answers",
			correct_answers: "Correct answers",
			players: "players",
			photo_show: "Team photos",
			go_to_stage: "A representative of your team must go on the stage",
			this_groups_to_stage: "Waiting for the teams to go to the stage",
			challenge_start_soon: "Wait for the selected representatives to go on stage",
			turn_of_team: "Team's turn",
			vote_of_team: "Time to vote",
			placement: "Team positioning",
			draw: "Draw",
			fill_write_answer: "Fill in answer",
			fill_answer: "Fill in answer",
			go_to_stage_all: "Let the whole team go on stage",
			quiz_write_answer: "Answering the quiz",
			photo_write_answer: "Sending the photos",
			upload_photo: "Take a photo",
			fill_answer_placeholder: "Write the answer",
			quiz: "Quiz",
			fill: "Fill in the phrase",
			two_vs_two: "Team challenge",
			one_vs_all: "Team survey",
			photo: "Photograph"
		},
		player: {
			bingo_start_soon: "Bingo will start soon",
			selecting_bingo: "Selecting Bingo",
			no_picture: "No team picture",
			upload_team_picture: "Upload team picture",
			not_started: "The activity has not started yet",
			photo_show: "Team photos",
			song_marked: "Song marked",
			answered: "Answered",
			correct_song: "Correct song",
			wrong_song: "Wrong song",
			error_marking_song: "Error marking the song",
			bingo_finished: "Bingo finished",
			winner_team: "Winning team",
			photo_screen: "Team photos",
			play: "Play",
			pause: "Pause",
			restart: "Restart",
			start_game: "START GAME",
			audio_permission_message: "Click the button below to enable audio playback for the game.",
			tab_muted_warning: "⚠️ Browser Tab is Muted",
			tab_muted_instructions: "Please unmute the browser tab by clicking the speaker icon in the browser tab to enable audio playback.",
			no_team_responding: "No team has responded correctly",
			final_ranking: "Final Ranking"
		},
		ranking_musical_bingo: {
			press_button_view_ranking: "Press the button to view the ranking",
			view_ranking: "View ranking"
		}
	},
	summaries: {
		description: "Download and manage facilitator summaries and reports",
		monitor_summaries: "Facilitator Summaries",
		download_monitor_summary: "Download Facilitator Summary",
		select_month: "Select Month",
		select_month_description: "Choose the month for which you want to download the facilitator summary report.",
		download: "Download",
		download_success: "Download Successful",
		download_success_detail: "Facilitator summary for {month} has been downloaded successfully.",
		download_error: "Download Error",
		download_error_detail: "An error occurred while downloading the facilitator summary. Please try again."
	},
	staff_page: {
		title: "Staff records",
		description: "View and manage gamemaster records by date range.",
		date_range: "Date range",
		select_year: "Year",
		select_month: "Month",
		all_months: "All months",
		filter_by_staff: "Filter by staff",
		filter_by_accepted: "Accepted status",
		all_staff: "All staff",
		filter_by_paid: "Payment status",
		all: "All",
		paid: "Paid",
		not_paid: "Not paid",
		booking: "Booking",
		booking_name: "Booking name",
		date: "Date",
		staff: "Staff",
		salary: "Salary",
		accepted: "Accepted",
		responsible: "Responsible",
		paid_status: "Paid",
		comments: "Comments",
		mark_selected_paid: "Mark selected as paid",
		mark_selected_not_paid: "Mark selected as not paid",
		mark_all_paid: "Mark all as paid",
		mark_all_not_paid: "Mark all as not paid",
		update_success: "Records updated successfully",
		update_error: "Error updating records. Please try again.",
		select_records: "Select one or more records",
		loading: "Loading...",
		no_records: "No records found for the selected period.",
		records_updated: "{count} record(s) updated",
		total_salary: "Total salary",
		total_salary_to_be_paid: "Total salary to be paid"
	},
	gm_activities_page: {
		description: "Review your activities, payments, and pending bookings.",
		activities: "Activities",
		pending_reservation: "Pending booking"
	}
}